// // import React, { useEffect, useState } from "react";
// // import { motion } from "framer-motion";
// // import Api from "../Utills/Api";
// // import { useNavigate } from "react-router-dom";
// // import logo from "../../Frozenwala.png";
// // import axios from "axios";
// // import "./Product.css";
// // import Pagination from "@mui/material/Pagination";
// // import Stack from "@mui/material/Stack";
// // import { styled } from "@mui/material/styles";
// // import { CiHeart } from "react-icons/ci";
// // import { FaHeart } from "react-icons/fa";
// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { useWishlist } from "../../contexts/WishlistContext";

// // const StyledPagination = styled(Pagination)(() => ({
// //   "& .MuiPaginationItem-root": {
// //     color: "#5dc5fa",
// //     borderRadius: "50%",
// //     fontWeight: "600",
// //     transition: "all 0.3s ease",
// //     "&:hover": {
// //       backgroundColor: "#ffece4",
// //       color: "#5dc5fa",
// //       transform: "scale(1.1)",
// //     },
// //     minWidth: "25px",
// //     height: "25px",
// //     maxHeight: "32px",
// //   },
// //   "& .Mui-selected": {
// //     backgroundColor: "#5dc5fa !important",
// //     color: "#fff !important",
// //     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
// //     transform: "scale(1.15)",
// //   },
// //   "& .MuiPagination-ul": {
// //     gap: "8px",
// //   },
// // }));

// // function Product({ refreshCart, getProducts, getAllProducts, products, categoryCounts }) {
// //   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage } = useWishlist();
// //   const [categories, setCategories] = useState([]);
// //   const [selectedCategory, setSelectedCategory] = useState("all");
// //   const [cartItems, setCartItems] = useState({});
// //   const [stock, setStock] = useState({});
// //   const uid = localStorage.getItem("user_id");
// //   const navigate = useNavigate();
// //   const pageSize = 20;
// //   const totalPages = Math.ceil(products.length / pageSize);
// //   const currentData = products.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

// //   useEffect(() => {
// //     getMenu();
// //     getStock();
// //     getCartItems();
// //   }, []);

// //   const getMenu = async () => {
// //     try {
// //       const response = await axios.get(
// //         `https://backend.frozenwala.com/api/auth/categories/`
// //       );
// //       setCategories(response.data);
// //     } catch (error) {
// //       console.error("Error fetching categories:", error);
// //     }
// //   };

// //   const handleClick = async (categoryId) => {
// //     setItemsPage(1);
// //     setSelectedCategory(categoryId);
// //     if (categoryId === "all") getAllProducts();
// //     else getProducts(categoryId);
// //   };

// //   const getCartItems = async () => {
// //     try {
// //       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
// //       const map = {};
// //       response.data.forEach((item) => (map[item.product_id] = item.quantity));
// //       setCartItems(map);
// //     } catch (error) {
// //       console.error("Error fetching cart items:", error);
// //     }
// //   };

// //   const getStock = async () => {
// //     try {
// //       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
// //       const map = {};
// //       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
// //       setStock(map);
// //     } catch (error) {
// //       console.error("Error getting stock:", error);
// //     }
// //   };

// //   const onPressAddToCart = async (productId) => {
// //     const available = stock[productId];
// //     if (available === 0) {
// //       alert("No stock available");
// //       return;
// //     }
// //     if (uid) {
// //       try {
// //         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
// //         refreshCart();
// //         setCartItems((prev) => ({
// //           ...prev,
// //           [productId]: (prev[productId] || 0) + 1,
// //         }));
// //       } catch (error) {
// //         console.error("Error adding product:", error);
// //       }
// //     } else navigate("/login");
// //   };

// //   const addOne = async (productId) => {
// //     const available = stock[productId];
// //     const currentQty = cartItems[productId] || 0;
// //     if (available > currentQty) {
// //       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
// //       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
// //       refreshCart();
// //     } else {
// //       alert(`Only ${available} items available in stock.`);
// //     }
// //   };

// //   const subOne = async (productId) => {
// //     if (cartItems[productId] > 1) {
// //       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
// //       setCartItems((prev) => ({
// //         ...prev,
// //         [productId]: prev[productId] - 1,
// //       }));
// //     }
// //   };

// //   return (
// //     <div className="min-vh-100 py-4">
// //       <ToastContainer position="top-center" autoClose={1500} />

// //       {/* Title */}
// //       <motion.div
// //         initial={{ opacity: 0, y: -30 }}
// //         animate={{ opacity: 1, y: 0 }}
// //         transition={{ duration: 0.6 }}
// //         className="text-center mb-4"
// //       >
// //         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
// //         <p className="text-muted">Explore categories and add your favorites!</p>
// //       </motion.div>

// //       {/* Category Buttons */}
// //       <motion.div
// //         className="container d-flex flex-wrap justify-content-center gap-2 mb-5"
// //         initial={{ opacity: 0 }}
// //         animate={{ opacity: 1 }}
// //         transition={{ delay: 0.2, duration: 0.8 }}
// //       >
// //         {["all", ...categories.map((c) => c.id)].map((id, index) => {
// //           const name =
// //             id === "all" ? "All Products" : categories.find((c) => c.id === id)?.name;
// //           const count = id === "all" ? products.length : categoryCounts[id];
// //           const isSelected = selectedCategory === id;

// //           return (
// //             <motion.button
// //               key={index}
// //               whileHover={{ scale: 1.05 }}
// //               whileTap={{ scale: 0.95 }}
// //               onClick={() => handleClick(id)}
// //               className="btn"
// //               style={{
// //                 backgroundColor: isSelected ? "#5dc5fa" : "#fff",
// //                 color: isSelected ? "#fff" : "#5dc5fa",
// //                 border: "2px solid #5dc5fa",
// //                 borderRadius: "50px",
// //                 fontWeight: "600",
// //                 padding: "8px 18px",
// //               }}
// //             >
// //               {name} {count ? `(${count})` : ""}
// //             </motion.button>
// //           );
// //         })}
// //       </motion.div>

// //       {/* Products Grid */}
// //       <div className="container">
// //         <motion.div
// //           layout
// //           className="row gy-4 justify-content-center"
// //           initial="hidden"
// //           animate="visible"
// //           variants={{
// //             hidden: { opacity: 0, y: 20 },
// //             visible: {
// //               opacity: 1,
// //               y: 0,
// //               transition: { staggerChildren: 0.05 },
// //             },
// //           }}
// //         >
// //           {currentData.map((product) => {
// //             const isSoldOut = product.stock === 0;
// //             const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

// //             return (
// //               <motion.div
// //                 key={product.id}
// //                 className="col-6 col-sm-6 col-md-4 col-lg-3"
// //               >
// //                 <motion.div className="card product-card border-0 rounded-4 h-100 position-relative" style={{cursor:"pointer"}} >
// //                   {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

// //                   {/* ❤️ Wishlist Icon */}
// //                   <div
// //                     onClick={() => !wishlistLoading && toggleWishlist(product)}
// //                     style={{
// //                       position: "absolute",
// //                       top: "10px",
// //                       right: "10px",
// //                       cursor: "pointer",
// //                     }}
// //                   >
// //                     {isInWishlist ? (
// //                       <FaHeart size={26} color="red" />
// //                     ) : (
// //                       <CiHeart size={26} color="#bbb" />
// //                     )}
// //                   </div>

// //                   <img
// //                     src={product.item_photo || logo}
// //                     alt={product.title}
// //                     className="img-fluid w-100 product-img"
// //                     onClick={()=>navigate(`products/${product.id}`)}
// //                   />
// //                   <div className="card-body px-0 text-center" >
// //                     <h6 className="fw-bold text-dark text-truncate" style={{ textAlign: "left" }}>
// //                       {product.title}
// //                     </h6>
// //                       <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
// //                         <p
// //                           className="old-price"
// //                           style={{
// //                             textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
// //                             color: "#999",
// //                             fontSize: "0.83333rem",
// //                           }}
// //                         >
// //                           ₹{product.item_old_price || 0}
// //                         </p>
// //                         <p className="fw-semibold" style={{fontSize: "0.83333rem"}}>
// //                           ₹{product.item_new_price}
// //                         </p>
// //                         <p className="discount-badge" style={{ 
// //                           color: 'green', 
// //                           fontSize: '0.83333rem', 
// //                         }}>
// //                           {product.discount_percentage}% OFF
// //                         </p>
// //                       </div>
// //                     {cartItems[product.id] && !isSoldOut ? (
// //                       <div className="d-flex justify-content-center align-items-center gap-2">
// //                         <button className="qty-btn" onClick={() => subOne(product.id)}>
// //                           -
// //                         </button>
// //                         <span className="fw-bold">{cartItems[product.id]}</span>
// //                         <button className="qty-btn" onClick={() => addOne(product.id)}>
// //                           +
// //                         </button>
// //                       </div>
// //                     ) : (
// //                       <motion.button
// //                         whileHover={{ scale: 1.1 }}
// //                         className="btn btn-danger btn-sm rounded-pill"
// //                         onClick={() => onPressAddToCart(product.id)}
// //                         disabled={isSoldOut}
// //                         style={{padding: "6px 12px", fontSize: "12px"}}
// //                       >
// //                         Add to Cart
// //                       </motion.button>
// //                     )}
// //                   </div>
// //                 </motion.div>
// //               </motion.div>
// //             );
// //           })}
// //         </motion.div>

// //         {/* Pagination */}
// //         <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
// //           <StyledPagination
// //             count={totalPages}
// //             page={itemsPage}
// //             onChange={(event, value) => setItemsPage(value)}
// //             shape="rounded"
// //             color="primary"
// //           />
// //         </Stack>
// //       </div>
// //     </div>
// //   );
// // }

// // import React, { useEffect, useState } from "react";
// // import { motion } from "framer-motion";
// // import Api from "../Utills/Api";
// // import { useNavigate } from "react-router-dom";
// // import logo from "../../Frozenwala.png";
// // import axios from "axios";
// // import "./Product.css";
// // import Pagination from "@mui/material/Pagination";
// // import Stack from "@mui/material/Stack";
// // import { styled } from "@mui/material/styles";
// // import { CiHeart } from "react-icons/ci";
// // import { FaHeart } from "react-icons/fa";
// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { useWishlist } from "../../contexts/WishlistContext";

// // const StyledPagination = styled(Pagination)(() => ({
// //   "& .MuiPaginationItem-root": {
// //     color: "#5dc5fa",
// //     borderRadius: "50%",
// //     fontWeight: "600",
// //     transition: "all 0.3s ease",
// //     "&:hover": {
// //       backgroundColor: "#ffece4",
// //       color: "#5dc5fa",
// //       transform: "scale(1.1)",
// //     },
// //     minWidth: "25px",
// //     height: "25px",
// //     maxHeight: "32px",
// //   },
// //   "& .Mui-selected": {
// //     backgroundColor: "#5dc5fa !important",
// //     color: "#fff !important",
// //     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
// //     transform: "scale(1.15)",
// //   },
// //   "& .MuiPagination-ul": {
// //     gap: "8px",
// //   },
// // }));

// // function Product({ refreshCart, getProducts, getAllProducts, products, categoriesWithCounts = [], selectedBrands = [], loading = false }) {
// //   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage } = useWishlist();
// //   const [selectedCategory, setSelectedCategory] = useState("all");
// //   const [cartItems, setCartItems] = useState({});
// //   const [stock, setStock] = useState({});
// //   const uid = localStorage.getItem("user_id");
// //   const navigate = useNavigate();
// //   const pageSize = 20;

// //   const totalPages = Math.ceil(products.length / pageSize);
// //   const currentData = products.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

// //   useEffect(() => {
// //     getStock();
// //     getCartItems();
// //   }, []);

// //   // Reset to page 1 when filters change
// //   useEffect(() => {
// //     setItemsPage(1);
// //   }, [selectedBrands, products]);

// //   const handleClick = async (categoryId) => {
// //     setItemsPage(1);
// //     setSelectedCategory(categoryId);
// //     if (categoryId === "all") {
// //       getAllProducts();
// //     } else {
// //       getProducts(categoryId);
// //     }
// //   };

// //   const getCartItems = async () => {
// //     try {
// //       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
// //       const map = {};
// //       response.data.forEach((item) => (map[item.product_id] = item.quantity));
// //       setCartItems(map);
// //     } catch (error) {
// //       console.error("Error fetching cart items:", error);
// //     }
// //   };

// //   const getStock = async () => {
// //     try {
// //       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
// //       const map = {};
// //       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
// //       setStock(map);
// //     } catch (error) {
// //       console.error("Error getting stock:", error);
// //     }
// //   };

// //   const onPressAddToCart = async (productId) => {
// //     const available = stock[productId];
// //     if (available === 0) {
// //       alert("No stock available");
// //       return;
// //     }
// //     if (uid) {
// //       try {
// //         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
// //         refreshCart();
// //         setCartItems((prev) => ({
// //           ...prev,
// //           [productId]: (prev[productId] || 0) + 1,
// //         }));
// //       } catch (error) {
// //         console.error("Error adding product:", error);
// //       }
// //     } else navigate("/login");
// //   };

// //   const addOne = async (productId) => {
// //     const available = stock[productId];
// //     const currentQty = cartItems[productId] || 0;
// //     if (available > currentQty) {
// //       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
// //       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
// //       refreshCart();
// //     } else {
// //       alert(`Only ${available} items available in stock.`);
// //     }
// //   };

// //   const subOne = async (productId) => {
// //     if (cartItems[productId] > 1) {
// //       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
// //       setCartItems((prev) => ({
// //         ...prev,
// //         [productId]: prev[productId] - 1,
// //       }));
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <div className="min-vh-100 d-flex justify-content-center align-items-center">
// //         <div className="text-center">
// //           <div className="spinner-border text-danger" role="status" style={{ width: "3rem", height: "3rem" }}>
// //             <span className="visually-hidden">Loading products...</span>
// //           </div>
// //           <p className="mt-3 text-muted">Loading delicious products...</p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="min-vh-100 py-4">
// //       <ToastContainer position="top-center" autoClose={1500} />

// //       <motion.div
// //         initial={{ opacity: 0, y: -30 }}
// //         animate={{ opacity: 1, y: 0 }}
// //         transition={{ duration: 0.6 }}
// //         className="text-center mb-4"
// //       >
// //         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
// //         <p className="text-muted">
// //           Explore categories and add your favorites!
// //         </p>
// //       </motion.div>

// //       <motion.div
// //         className="container d-flex flex-wrap justify-content-center gap-2 mb-5"
// //         initial={{ opacity: 0 }}
// //         animate={{ opacity: 1 }}
// //         transition={{ delay: 0.2, duration: 0.8 }}
// //       >
// //         {/* All Products button */}
// //         <motion.button
// //           whileHover={{ scale: 1.05 }}
// //           whileTap={{ scale: 0.95 }}
// //           onClick={() => handleClick("all")}
// //           className="btn"
// //           style={{
// //             backgroundColor: selectedCategory === "all" ? "#5dc5fa" : "#fff",
// //             color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
// //             border: "2px solid #5dc5fa",
// //             borderRadius: "50px",
// //             fontWeight: "600",
// //             padding: "8px 18px",
// //             cursor: "pointer",
// //           }}
// //         >
// //           All Products ({products.length})
// //         </motion.button>

// //         {/* Category buttons from API with total_items counts */}
// //         {categoriesWithCounts.map((category) => {
// //           const isSelected = selectedCategory === category.id;
// //           const count = category.total_items || 0;

// //           return (
// //             <motion.button
// //               key={category.id}
// //               whileHover={{ scale: 1.05 }}
// //               whileTap={{ scale: 0.95 }}
// //               onClick={() => handleClick(category.id)}
// //               className="btn"
// //               style={{
// //                 backgroundColor: isSelected ? "#5dc5fa" : "#fff",
// //                 color: isSelected ? "#fff" : "#5dc5fa",
// //                 border: "2px solid #5dc5fa",
// //                 borderRadius: "50px",
// //                 fontWeight: "600",
// //                 padding: "8px 18px",
// //                 cursor: "pointer",
// //               }}
// //             >
// //               {category.name} ({count})
// //             </motion.button>
// //           );
// //         })}
// //       </motion.div>

// //       {products.length === 0 ? (
// //         <div className="container text-center py-5">
// //           <motion.div
// //             initial={{ opacity: 0, scale: 0.9 }}
// //             animate={{ opacity: 1, scale: 1 }}
// //             transition={{ duration: 0.5 }}
// //           >
// //             <img 
// //               src="/img/gallery/no-products.svg" 
// //               alt="No products found" 
// //               style={{ width: "200px", marginBottom: "20px" }}
// //               onError={(e) => e.target.style.display = "none"}
// //             />
// //             <h3 className="text-muted mb-3">No products found</h3>
// //             <p className="text-secondary">
// //               {selectedBrands.length > 0 
// //                 ? `No products available for the selected brand${selectedBrands.length > 1 ? 's' : ''}: ${selectedBrands.join(', ')}`
// //                 : "No products available at the moment."
// //               }
// //             </p>
// //             {selectedBrands.length > 0 && (
// //               <>
// //                 <p className="text-secondary small">
// //                   Try selecting different brands or clear the filters to see all products.
// //                 </p>
// //                 <button 
// //                   className="btn btn-outline-danger rounded-pill px-4 mt-3"
// //                   style={{color:"black"}}
// //                   onClick={() => {
// //                     window.location.reload();
// //                   }}
// //                 >
// //                   Clear Filters
// //                 </button>
// //               </>
// //             )}
// //           </motion.div>
// //         </div>
// //       ) : (
// //         <>
// //           {/* Products Grid */}
// //           <div className="container">
// //             <motion.div
// //               layout
// //               className="row gy-4 justify-content-center"
// //               initial="hidden"
// //               animate="visible"
// //               variants={{
// //                 hidden: { opacity: 0, y: 20 },
// //                 visible: {
// //                   opacity: 1,
// //                   y: 0,
// //                   transition: { staggerChildren: 0.05 },
// //                 },
// //               }}
// //             >
// //               {currentData.map((product) => {
// //                 const isSoldOut = product.stock === 0;
// //                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

// //                 return (
// //                   <motion.div
// //                     key={product.id}
// //                     className="col-6 col-sm-6 col-md-4 col-lg-3"
// //                   >
// //                     <motion.div className="card product-card border-0 rounded-4 h-100 position-relative" style={{cursor:"pointer"}} >
// //                       {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

// //                       {/* ❤️ Wishlist Icon */}
// //                       <div
// //                         onClick={() => !wishlistLoading && toggleWishlist(product)}
// //                         style={{
// //                           position: "absolute",
// //                           top: "10px",
// //                           right: "10px",
// //                           cursor: "pointer",
// //                           zIndex: 2,
// //                         }}
// //                       >
// //                         {isInWishlist ? (
// //                           <FaHeart size={26} color="red" />
// //                         ) : (
// //                           <CiHeart size={26} color="#bbb" />
// //                         )}
// //                       </div>

// //                       <img
// //                         src={product.item_photo || logo}
// //                         alt={product.title}
// //                         className="img-fluid w-100 product-img"
// //                         onClick={()=>navigate(`products/${product.id}`)}
// //                         style={{ cursor: "pointer" }}
// //                       />
// //                       <div className="card-body px-0 text-center" >
// //                         <h6 className="fw-bold text-dark text-truncate" style={{ textAlign: "left" }}>
// //                           {product.title}
// //                         </h6>
// //                         <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
// //                           <p
// //                             className="old-price"
// //                             style={{
// //                               textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
// //                               color: "#999",
// //                               fontSize: "0.83333rem",
// //                             }}
// //                           >
// //                             ₹{product.item_old_price || 0}
// //                           </p>
// //                           <p className="fw-semibold" style={{fontSize: "0.83333rem"}}>
// //                             ₹{product.item_new_price}
// //                           </p>
// //                           <p className="discount-badge" style={{ 
// //                             color: 'green', 
// //                             fontSize: '0.83333rem', 
// //                           }}>
// //                             {product.discount_percentage}% OFF
// //                           </p>
// //                         </div>
// //                         {cartItems[product.id] && !isSoldOut ? (
// //                           <div className="d-flex justify-content-center align-items-center gap-2">
// //                             <button className="qty-btn" onClick={() => subOne(product.id)}>
// //                               -
// //                             </button>
// //                             <span className="fw-bold">{cartItems[product.id]}</span>
// //                             <button className="qty-btn" onClick={() => addOne(product.id)}>
// //                               +
// //                             </button>
// //                           </div>
// //                         ) : (
// //                           <motion.button
// //                             whileHover={{ scale: 1.1 }}
// //                             className="btn btn-danger btn-sm rounded-pill"
// //                             onClick={() => onPressAddToCart(product.id)}
// //                             disabled={isSoldOut}
// //                             style={{padding: "6px 12px", fontSize: "12px"}}
// //                           >
// //                             Add to Cart
// //                           </motion.button>
// //                         )}
// //                       </div>
// //                     </motion.div>
// //                   </motion.div>
// //                 );
// //               })}
// //             </motion.div>

// //             {/* Pagination */}
// //             {totalPages > 1 && (
// //               <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
// //                 <StyledPagination
// //                   count={totalPages}
// //                   page={itemsPage}
// //                   onChange={(event, value) => setItemsPage(value)}
// //                   shape="rounded"
// //                   color="primary"
// //                 />
// //               </Stack>
// //             )}
// //           </div>
// //         </>
// //       )}
// //     </div>
// //   );
// // }

// // export default Product;

// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import axios from "axios";
// import "./Product.css";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { styled } from "@mui/material/styles";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useWishlist } from "../../contexts/WishlistContext";

// const StyledPagination = styled(Pagination)(() => ({
//   "& .MuiPaginationItem-root": {
//     color: "#5dc5fa",
//     borderRadius: "50%",
//     fontWeight: "600",
//     transition: "all 0.3s ease",
//     "&:hover": {
//       backgroundColor: "#ffece4",
//       color: "#5dc5fa",
//       transform: "scale(1.1)",
//     },
//     minWidth: "25px",
//     height: "25px",
//     maxHeight: "32px",
//   },
//   "& .Mui-selected": {
//     backgroundColor: "#5dc5fa !important",
//     color: "#fff !important",
//     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
//     transform: "scale(1.15)",
//   },
//   "& .MuiPagination-ul": {
//     gap: "8px",
//   },
// }));

// function Product({ refreshCart, getProducts, getAllProducts, products, categoriesWithCounts = [], selectedBrands = [], loading = false, totalItems = 0 }) {
//   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage } = useWishlist();
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();
//   const pageSize = 20;

//   // Ensure products is always an array
//   const productsArray = Array.isArray(products) ? products : [];
//   const totalPages = Math.ceil(productsArray.length / pageSize);
//   const currentData = productsArray.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

//   useEffect(() => {
//     getStock();
//     getCartItems();
//   }, []);

//   // Reset to page 1 when filters change
//   useEffect(() => {
//     setItemsPage(1);
//   }, [selectedBrands, productsArray]);

//   const handleClick = async (categoryId) => {
//     setItemsPage(1);
//     setSelectedCategory(categoryId);
//     if (categoryId === "all") {
//       getAllProducts();
//     } else {
//       getProducts(categoryId);
//     }
//   };

//   const getCartItems = async () => {
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       alert("No stock available");
//       return;
//     }
//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//         refreshCart();
//         setCartItems((prev) => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1,
//         }));
//       } catch (error) {
//         console.error("Error adding product:", error);
//       }
//     } else navigate("/login");
//   };

//   const addOne = async (productId) => {
//     const available = stock[productId];
//     const currentQty = cartItems[productId] || 0;
//     if (available > currentQty) {
//       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//       refreshCart();
//     } else {
//       alert(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (cartItems[productId] > 1) {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: prev[productId] - 1,
//       }));
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-vh-100 d-flex justify-content-center align-items-center">
//         <div className="text-center">
//           <div className="spinner-border text-danger" role="status" style={{ width: "3rem", height: "3rem" }}>
//             <span className="visually-hidden">Loading products...</span>
//           </div>
//           <p className="mt-3 text-muted">Loading delicious products...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-vh-100 py-4">
//       <ToastContainer position="top-center" autoClose={1500} />

//       <motion.div
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="text-center mb-4"
//       >
//         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
//         <p className="text-muted">
//           Explore categories and add your favorites!

//         </p>
//       </motion.div>

//       <motion.div
//         className="container d-flex flex-wrap justify-content-center gap-2 mb-5"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.8 }}
//       >
//         {/* All Products button - using totalItems for accurate count */}
//         <motion.button
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           onClick={() => handleClick("all")}
//           className="btn"
//           style={{
//             backgroundColor: selectedCategory === "all" ? "#5dc5fa" : "#fff",
//             color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
//             border: "2px solid #5dc5fa",
//             borderRadius: "50px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             cursor: "pointer",
//           }}
//         >
//           All Products ({totalItems || productsArray.length})
//         </motion.button>

//         {/* Category buttons from API with total_items counts */}
//         {categoriesWithCounts.map((category) => {
//           const isSelected = selectedCategory === category.id;
//           // ✅ CORRECT — read "count" which ParentComponent keeps updated, fall back to total_items
// const count = category.count ?? category.total_items ?? 0;

//           return (
//             <motion.button
//               key={category.id}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => handleClick(category.id)}
//               className="btn"
//               style={{
//                 backgroundColor: isSelected ? "#5dc5fa" : "#fff",
//                 color: isSelected ? "#fff" : "#5dc5fa",
//                 border: "2px solid #5dc5fa",
//                 borderRadius: "50px",
//                 fontWeight: "600",
//                 padding: "8px 18px",
//                 cursor: "pointer",
//               }}
//             >
//               {category.name} ({count})
//             </motion.button>
//           );
//         })}
//       </motion.div>

//       {productsArray.length === 0 ? (
//         <div className="container text-center py-5">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//           >
//             <img 
//               src="/img/gallery/no-products.svg" 
//               alt="No products found" 
//               style={{ width: "200px", marginBottom: "20px" }}
//               onError={(e) => e.target.style.display = "none"}
//             />
//             <h3 className="text-muted mb-3">No products found</h3>
//             <p className="text-secondary">
//               {selectedBrands.length > 0 
//                 ? `No products available for the selected brand${selectedBrands.length > 1 ? 's' : ''}: ${selectedBrands.join(', ')}`
//                 : "No products available at the moment."
//               }
//             </p>
//             {selectedBrands.length > 0 && (
//               <>
//                 <p className="text-secondary small">
//                   Try selecting different brands or clear the filters to see all products.
//                 </p>
//                 <button 
//                   className="btn btn-outline-danger rounded-pill px-4 mt-3"
//                   style={{color:"black"}}
//                   onClick={() => {
//                     window.location.reload();
//                   }}
//                 >
//                   Clear Filters
//                 </button>
//               </>
//             )}
//           </motion.div>
//         </div>
//       ) : (
//         <>
//           {/* Products Grid */}
//           <div className="container">
//             <motion.div
//               layout
//               className="row gy-4 justify-content-center"
//               initial="hidden"
//               animate="visible"
//               variants={{
//                 hidden: { opacity: 0, y: 20 },
//                 visible: {
//                   opacity: 1,
//                   y: 0,
//                   transition: { staggerChildren: 0.05 },
//                 },
//               }}
//             >
//               {currentData.map((product) => {
//                 const isSoldOut = product.stock === 0;
//                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

//                 return (
//                   <motion.div
//                     key={product.id}
//                     className="col-6 col-sm-6 col-md-4 col-lg-3"
//                   >
//                     <motion.div className="card product-card border-0 rounded-4 h-100 position-relative" style={{cursor:"pointer"}} >
//                       {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

//                       {/* ❤️ Wishlist Icon */}
//                       <div
//                         onClick={() => !wishlistLoading && toggleWishlist(product)}
//                         style={{
//                           position: "absolute",
//                           top: "10px",
//                           right: "10px",
//                           cursor: "pointer",
//                           zIndex: 2,
//                         }}
//                       >
//                         {isInWishlist ? (
//                           <FaHeart size={26} color="red" />
//                         ) : (
//                           <CiHeart size={26} color="#bbb" />
//                         )}
//                       </div>

//                       <img
//                         src={product.item_photo || logo}
//                         alt={product.title}
//                         className="img-fluid w-100 product-img"
//                         onClick={()=>navigate(`products/${product.id}`)}
//                         style={{ cursor: "pointer" }}
//                       />
//                       <div className="card-body px-0 text-center" >
//                         <h6 className="fw-bold text-dark text-truncate" style={{ textAlign: "left" }}>
//                           {product.title}
//                         </h6>
//                         <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
//                           <p
//                             className="old-price"
//                             style={{
//                               textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
//                               color: "#999",
//                               fontSize: "0.83333rem",
//                             }}
//                           >
//                             ₹{product.item_old_price || 0}
//                           </p>
//                           <p className="fw-semibold" style={{fontSize: "0.83333rem"}}>
//                             ₹{product.item_new_price}
//                           </p>
//                           <p className="discount-badge" style={{ 
//                             color: 'green', 
//                             fontSize: '0.83333rem', 
//                           }}>
//                             {product.discount_percentage}% OFF
//                           </p>
//                         </div>
//                         {cartItems[product.id] && !isSoldOut ? (
//                           <div className="d-flex justify-content-center align-items-center gap-2">
//                             <button className="qty-btn" onClick={() => subOne(product.id)}>
//                               -
//                             </button>
//                             <span className="fw-bold">{cartItems[product.id]}</span>
//                             <button className="qty-btn" onClick={() => addOne(product.id)}>
//                               +
//                             </button>
//                           </div>
//                         ) : (
//                           <motion.button
//                             whileHover={{ scale: 1.1 }}
//                             className="btn btn-danger btn-sm rounded-pill"
//                             onClick={() => onPressAddToCart(product.id)}
//                             disabled={isSoldOut}
//                             style={{padding: "6px 12px", fontSize: "12px"}}
//                           >
//                             Add to Cart
//                           </motion.button>
//                         )}
//                       </div>
//                     </motion.div>
//                   </motion.div>
//                 );
//               })}
//             </motion.div>

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
//                 <StyledPagination
//                   count={totalPages}
//                   page={itemsPage}
//                   onChange={(event, value) => setItemsPage(value)}
//                   shape="rounded"
//                   color="primary"
//                 />
//               </Stack>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Product;

// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import axios from "axios";
// import "./Product.css";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { styled } from "@mui/material/styles";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useWishlist } from "../../contexts/WishlistContext";

// const StyledPagination = styled(Pagination)(() => ({
//   "& .MuiPaginationItem-root": {
//     color: "#5dc5fa",
//     borderRadius: "50%",
//     fontWeight: "600",
//     transition: "all 0.3s ease",
//     "& :hover": {
//       backgroundColor: "#ffece4",
//       color: "#5dc5fa",
//       transform: "scale(1.1)",
//     },
//     minWidth: "25px",
//     height: "25px",
//     maxHeight: "32px",
//   },
//   "& .Mui-selected": {
//     backgroundColor: "#5dc5fa !important",
//     color: "#fff !important",
//     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
//     transform: "scale(1.15)",
//   },
//   "& .MuiPagination-ul": {
//     gap: "8px",
//   },
// }));

// function Product({ refreshCart, getProducts, getAllProducts, products, categoriesWithCounts = [], selectedBrands = [], loading = false, totalItems = 0 }) {
//   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage } = useWishlist();
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();
//   const pageSize = 12;

//   const productsArray = Array.isArray(products) ? products : [];
//   const totalPages = Math.ceil(productsArray.length / pageSize);
//   const currentData = productsArray.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

//   useEffect(() => {
//     getStock();
//     getCartItems();
//   }, []);
//   useEffect(() => {
//     setSelectedCategory("all");
//     setItemsPage(1);
//   }, [selectedBrands]); 
//   useEffect(() => {
//     setItemsPage(1);
//   }, [selectedBrands, productsArray]);

//   const handleClick = async (categoryId) => {
//     setItemsPage(1);
//     setSelectedCategory(categoryId);
//     if (categoryId === "all") {
//       getAllProducts();
//     } else {
//       getProducts(categoryId);
//     }
//   };

//   const getCartItems = async () => {
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       alert("No stock available");
//       return;
//     }
//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//         refreshCart();
//         setCartItems((prev) => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1,
//         }));
//       } catch (error) {
//         console.error("Error adding product:", error);
//       }
//     } else navigate("/login");
//   };

//   const addOne = async (productId) => {
//     const available = stock[productId];
//     const currentQty = cartItems[productId] || 0;
//     if (available > currentQty) {
//       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//       refreshCart();
//     } else {
//       alert(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (cartItems[productId] > 1) {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: prev[productId] - 1,
//       }));
//     }
//   };

//   // Safe global design overrides for symmetric frames and component spacing bounds
//   const structuralStyles = (
//     <style>{`
//       .category-buttons-scroll-wrap {
//         display: flex !important;
//         flex-wrap: nowrap !important;
//         overflow-x: auto !important;
//         -webkit-overflow-scrolling: touch;
//         padding-bottom: 8px;
//         justify-content: flex-start !important;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar {
//         height: 4px;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar-thumb {
//         background-color: #ffece4;
//         border-radius: 4px;
//       }
//       @media (min-width: 768px) {
//         .category-buttons-scroll-wrap {
//           flex-wrap: wrap !important;
//           justify-content: center !important;
//           overflow-x: visible !important;
//         }
//       }

//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       /* 🦴 Premium Skeleton Loading Effects */
//       .skeleton-block {
//         background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
//         background-size: 200% 100%;
//         animation: skeleton-pulse 1.5s infinite ease-in-out;
//       }
//       @keyframes skeleton-pulse {
//         0% { background-position: 200% 0; }
//         100% { background-position: -200% 0; }
//       }
//       .skeleton-title {
//         height: 16px;
//         width: 75%;
//         border-radius: 4px;
//         margin-bottom: 12px;
//       }
//       .skeleton-meta {
//         height: 14px;
//         width: 50%;
//         border-radius: 4px;
//         margin-bottom: 20px;
//       }
//       .skeleton-btn {
//         height: 35px;
//         width: 100%;
//         border-radius: 50px;
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container { --bs-gutter-x: 0.5rem !important; }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//       }
//     `}</style>
//   );

//   if (loading) {
//     return (
//       <div className="min-vh-100 py-4">
//         {structuralStyles}
//         <div className="container px-2">
//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
//               <div key={n} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-vh-100 py-4">
//       <ToastContainer position="top-center" autoClose={1500} />
//       {structuralStyles}

//       <motion.div
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="text-center mb-4"
//       >
//         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
//         <p className="text-muted">Explore categories and add your favorites!</p>
//       </motion.div>

//       <motion.div
//         className="container category-buttons-scroll-wrap gap-2 mb-5"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ delay: 0.2, duration: 0.8 }}
//       >
//         {/* ✅ "All Products" button */}
//         <motion.button
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           onClick={() => handleClick("all")}
//           className="btn"
//           style={{
//             backgroundColor: selectedCategory === "all" ? "#5dc5fa" : "#fff",
//             color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
//             border: "2px solid #5dc5fa",
//             borderRadius: "50px",
//             fontWeight: "600",
//             padding: "8px 18px",
//             cursor: "pointer",
//             whiteSpace: "nowrap"
//           }}
//         >
//           All Products ({totalItems})
//         </motion.button>

//         {/* ✅ Category buttons */}
//         {categoriesWithCounts.map((category) => {
//           const isSelected = selectedCategory === category.id;
//           const count = category.total_items ?? 0;

//           return (
//             <motion.button
//               key={category.id}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => handleClick(category.id)}
//               className="btn"
//               style={{
//                 backgroundColor: isSelected ? "#5dc5fa" : "#fff",
//                 color: isSelected ? "#fff" : "#5dc5fa",
//                 border: "2px solid #5dc5fa",
//                 borderRadius: "50px",
//                 fontWeight: "600",
//                 padding: "8px 18px",
//                 cursor: "pointer",
//                 whiteSpace: "nowrap"
//               }}
//             >
//               {category.name} ({count})
//             </motion.button>
//           );
//         })}
//       </motion.div>

//       {productsArray.length === 0 ? (
//         <div className="container text-center py-5">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//           >
//             <img
//               src="/img/gallery/no-products.svg"
//               alt="No products found"
//               style={{ width: "200px", marginBottom: "20px" }}
//               onError={(e) => e.target.style.display = "none"}
//             />
//             <h3 className="text-muted mb-3">No products found</h3>
//             <p className="text-secondary">
//               {selectedBrands.length > 0
//                 ? `No products available for the selected brand${selectedBrands.length > 1 ? 's' : ''}: ${selectedBrands.join(', ')}`
//                 : "No products available at the moment."
//               }
//             </p>
//             {selectedBrands.length > 0 && (
//               <>
//                 <p className="text-secondary small">
//                   Try selecting different brands or clear the filters to see all products.
//                 </p>
//                 <button
//                   className="btn btn-outline-danger rounded-pill px-4 mt-3"
//                   style={{ color: "black" }}
//                   onClick={() => window.location.reload()}
//                 >
//                   Clear Filters
//                 </button>
//               </>
//             )}
//           </motion.div>
//         </div>
//       ) : (
//         <>
//           <div className="container px-2">
//             <motion.div
//               layout
//               className="row gy-4 justify-content-center product-grid-container"
//               initial="hidden"
//               animate="visible"
//               variants={{
//                 hidden: { opacity: 0, y: 20 },
//                 visible: {
//                   opacity: 1,
//                   y: 0,
//                   transition: { staggerChildren: 0.05 },
//                 },
//               }}
//             >
//               {currentData.map((product) => {
//                 const isSoldOut = product.stock === 0;
//                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

//                 return (
//                   <motion.div key={product.id} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                     <motion.div className="card h-100 border-0 premium-card-wrapper">
//                       <div>

//                         {/* 🖼️ Symmetric Image Frame inside Card */}
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={() => !wishlistLoading && toggleWishlist(product)}
//                             style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", zIndex: 2 }}
//                           >
//                             {isInWishlist ? <FaHeart size={22} color="red" /> : <CiHeart size={22} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />}
//                           </div>

//                           <motion.img
//                             src={product.item_photo || logo}
//                             alt={product.title}
//                             className="symmetric-cover-img"
//                             onClick={() => navigate(`products/${product.id}`)}
//                             style={{ cursor: "pointer" }}
//                           />
//                         </div>

//                         {/* Description Layer */}
//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
//                             {product.title}
//                           </h6>
//                           <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px", flexWrap: "wrap" }}>
//                             <p
//                               className="old-price mb-0 mobile-price-size"
//                               style={{
//                                 textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{product.item_old_price || 0}
//                             </p>
//                             <p className="fw-semibold mb-0 mobile-price-size" style={{ fontSize: "0.83333rem" }}>
//                               ₹{product.item_new_price}
//                             </p>
//                             <p className="discount-badge mb-0 fw-bold" style={{ color: 'green', fontSize: '12px' }}>
//                               {product.discount_percentage}% OFF
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Pill-shaped Button Frame Wrapper */}
//                       <div className="w-100 mt-3">
//                         {cartItems[product.id] && !isSoldOut ? (
//                           <div className="d-flex justify-content-center align-items-center gap-2">
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => subOne(product.id)}>-</button>
//                             <span className="fw-bold text-dark mx-2">{cartItems[product.id]}</span>
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => addOne(product.id)}>+</button>
//                           </div>
//                         ) : (
//                           <motion.button
//                             whileHover={{ scale: 1.02 }}
//                             className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                             onClick={() => onPressAddToCart(product.id)}
//                             disabled={isSoldOut}
//                             style={{ backgroundColor: "#5dc5fa", border: "none", padding: "8px 0", fontSize: "13px" }}
//                           >
//                             Add to Cart
//                           </motion.button>
//                         )}
//                       </div>
//                     </motion.div>
//                   </motion.div>
//                 );
//               })}
//             </motion.div>

//             {totalPages > 1 && (
//               <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4, px: 2 }}>
//                 <StyledPagination
//                   count={totalPages}
//                   page={itemsPage}
//                   onChange={(event, value) => setItemsPage(value)}
//                   shape="rounded"
//                   color="primary"
//                   size="medium"
//                 />
//               </Stack>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Product;


// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import axios from "axios";
// import "./Product.css";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { styled } from "@mui/material/styles";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useWishlist } from "../../contexts/WishlistContext";
// import { FaFilter, FaTimes, FaChevronDown, FaChevronRight, FaRupeeSign, FaSlidersH } from "react-icons/fa";

// const StyledPagination = styled(Pagination)(() => ({
//   "& .MuiPaginationItem-root": {
//     color: "#5dc5fa",
//     borderRadius: "50%",
//     fontWeight: "600",
//     transition: "all 0.3s ease",
//     "& :hover": {
//       backgroundColor: "#ffece4",
//       color: "#5dc5fa",
//       transform: "scale(1.1)",
//     },
//     minWidth: "25px",
//     height: "25px",
//     maxHeight: "32px",
//   },
//   "& .Mui-selected": {
//     backgroundColor: "#5dc5fa !important",
//     color: "#fff !important",
//     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
//     transform: "scale(1.15)",
//   },
//   "& .MuiPagination-ul": {
//     gap: "8px",
//   },
// }));

// function Product({ 
//   refreshCart, 
//   getProducts, 
//   getAllProducts, 
//   products, 
//   categoriesWithCounts = [], 
//   selectedBrands = [], 
//   loading = false, 
//   totalItems = 0,
//   brands = []
// }) {
//   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage } = useWishlist();
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();
//   const pageSize = 12;

//   // Filter states
//   const [showFilterPanel, setShowFilterPanel] = useState(false);
//   const [expandedSections, setExpandedSections] = useState({
//     brands: true
//   });
//   const [selectedBrandFilters, setSelectedBrandFilters] = useState([]);
//   const [brandSearch, setBrandSearch] = useState("");

//   // Filter brands based on search
//   const filteredBrands = brands.filter(brand =>
//     brand.toLowerCase().includes(brandSearch.toLowerCase())
//   );

//   // Group filtered brands alphabetically
//   const groupedFilteredBrands = filteredBrands.reduce((groups, brand) => {
//     const firstLetter = brand.charAt(0).toUpperCase();
//     if (!groups[firstLetter]) {
//       groups[firstLetter] = [];
//     }
//     groups[firstLetter].push(brand);
//     return groups;
//   }, {});

//   const productsArray = Array.isArray(products) ? products : [];

//   // Apply brand filters to products
//   const filteredProducts = productsArray.filter(product => {
//     if (selectedBrandFilters.length === 0) return true;
//     const productBrand = product.brand || product.brand_name || product.item_brand || '';
//     return selectedBrandFilters.some(brand => 
//       productBrand.toLowerCase().includes(brand.toLowerCase())
//     );
//   });

//   // Calculate category counts based on filtered products
//   const getCategoryCount = (categoryId) => {
//     if (categoryId === 'all') {
//       return filteredProducts.length;
//     }
//     return filteredProducts.filter(product => {
//       const productCategoryId = product.category_id || product.category;
//       return productCategoryId === categoryId;
//     }).length;
//   };

//   const totalPages = Math.ceil(filteredProducts.length / pageSize);
//   const currentData = filteredProducts.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

//   useEffect(() => {
//     getStock();
//     getCartItems();
//   }, []);

//   useEffect(() => {
//     setSelectedCategory("all");
//     setItemsPage(1);
//   }, [selectedBrands]);

//   useEffect(() => {
//     setItemsPage(1);
//   }, [selectedBrands, productsArray, selectedBrandFilters]);

//   const handleClick = async (categoryId) => {
//     setItemsPage(1);
//     setSelectedCategory(categoryId);
//     if (categoryId === "all") {
//       getAllProducts();
//     } else {
//       getProducts(categoryId);
//     }
//   };

//   const getCartItems = async () => {
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       alert("No stock available");
//       return;
//     }
//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//         refreshCart();
//         setCartItems((prev) => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1,
//         }));
//       } catch (error) {
//         console.error("Error adding product:", error);
//       }
//     } else navigate("/login");
//   };

//   const addOne = async (productId) => {
//     const available = stock[productId];
//     const currentQty = cartItems[productId] || 0;
//     if (available > currentQty) {
//       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//       refreshCart();
//     } else {
//       alert(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (cartItems[productId] > 1) {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: prev[productId] - 1,
//       }));
//     }
//   };

//   // Filter handlers
//   const toggleSection = (section) => {
//     setExpandedSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   const handleBrandFilterChange = (brandName) => {
//     setSelectedBrandFilters(prev =>
//       prev.includes(brandName)
//         ? prev.filter(name => name !== brandName)
//         : [...prev, brandName]
//     );
//     // Reset to page 1 when filter changes
//     setItemsPage(1);
//   };

//   const clearAllFilters = () => {
//     setSelectedBrandFilters([]);
//     setBrandSearch("");
//     setItemsPage(1);
//   };

//   const applyFilters = () => {
//     toast.success(`Filtered by ${selectedBrandFilters.length} brand${selectedBrandFilters.length > 1 ? 's' : ''}!`);
//     setShowFilterPanel(false);
//   };

//   // Filter Panel Component - Left Side Slide In
//   const FilterPanel = () => (
//     <div
//       className={`filter-overlay ${showFilterPanel ? 'active' : ''}`}
//       onClick={() => setShowFilterPanel(false)}
//     >
//       <div
//         className={`filter-panel-slide ${showFilterPanel ? 'active' : ''}`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Filter Header */}
//         <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
//           <h5 className="fw-bold mb-0 d-flex align-items-center" style={{ color: '#333', fontSize: '18px' }}>
//             <FaSlidersH className="me-2" style={{ color: '#5dc5fa' }} />
//             Filters
//           </h5>
//           <div className="d-flex align-items-center gap-3">
//             <button 
//               onClick={clearAllFilters}
//               className="btn btn-link text-decoration-none p-0"
//               style={{ color: '#5dc5fa', fontSize: '14px', fontWeight: '600' }}
//             >
//               Clear All
//             </button>
//             <button
//               className="btn p-0"
//               onClick={() => setShowFilterPanel(false)}
//             >
//               <FaTimes size={20} />
//             </button>
//           </div>
//         </div>

//         <div className="filter-scroll-content">
//           {/* Brands Section */}
//           <div className="mb-3">
//             <div 
//               className="d-flex justify-content-between align-items-center py-2"
//               style={{ cursor: 'pointer', borderBottom: '1px solid #f5f5f5' }}
//               onClick={() => toggleSection('brands')}
//             >
//               <span className="fw-bold" style={{ fontSize: '15px', color: '#333' }}>Brands</span>
//               {expandedSections.brands ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}
//             </div>
//             {expandedSections.brands && (
//               <div className="mt-2">
//                 {/* Brand Search */}
//                 <div className="mb-3">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search brands..."
//                     value={brandSearch}
//                     onChange={(e) => setBrandSearch(e.target.value)}
//                     style={{
//                       border: '1px solid #ddd',
//                       borderRadius: '8px',
//                       padding: '8px 12px',
//                       fontSize: '14px'
//                     }}
//                   />
//                 </div>

//                 {/* Brands grouped alphabetically */}
//                 {Object.keys(groupedFilteredBrands)
//                   .sort()
//                   .map((letter) => (
//                     <div key={letter} className="mb-3">
//                       <div
//                         style={{
//                           fontWeight: 700,
//                           fontSize: '13px',
//                           color: '#5dc5fa',
//                           borderBottom: '1px solid #eee',
//                           paddingBottom: '4px',
//                           marginBottom: '8px'
//                         }}
//                       >
//                         {letter}
//                       </div>
//                       {groupedFilteredBrands[letter].map((brand, idx) => (
//                         <div
//                           key={`${letter}-${idx}`}
//                           className="d-flex align-items-center py-1"
//                           style={{ cursor: 'pointer' }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`brand-${brand}`}
//                             checked={selectedBrandFilters.includes(brand)}
//                             onChange={() => handleBrandFilterChange(brand)}
//                             style={{ accentColor: '#5dc5fa', width: '18px', height: '18px' }}
//                           />
//                           <label
//                             htmlFor={`brand-${brand}`}
//                             className="ms-3 mb-0"
//                             style={{ fontSize: '14px', color: '#555', cursor: 'pointer' }}
//                           >
//                             {brand}
//                           </label>
//                         </div>
//                       ))}
//                     </div>
//                   ))}
//                 {Object.keys(groupedFilteredBrands).length === 0 && (
//                   <p className="text-muted small">No brands found</p>
//                 )}

//                 {/* Show selected brands count */}
//                 {selectedBrandFilters.length > 0 && (
//                   <div className="mt-2 p-2" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
//                     <span className="text-muted small">
//                       Selected: {selectedBrandFilters.length} brand{selectedBrandFilters.length > 1 ? 's' : ''}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Apply Filters Button */}
//           <button
//             onClick={applyFilters}
//             className="btn w-100 mt-3"
//             style={{
//               background: '#5dc5fa',
//               color: '#fff',
//               borderRadius: '10px',
//               padding: '12px',
//               fontWeight: '600',
//               border: 'none',
//               fontSize: '15px'
//             }}
//           >
//             Apply Filters
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Safe global design overrides
//   const structuralStyles = (
//     <style>{`
//       .category-buttons-scroll-wrap {
//         display: flex !important;
//         flex-wrap: nowrap !important;
//         overflow-x: auto !important;
//         -webkit-overflow-scrolling: touch;
//         padding-bottom: 8px;
//         justify-content: flex-start !important;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar {
//         height: 4px;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar-thumb {
//         background-color: #ffece4;
//         border-radius: 4px;
//       }
//       @media (min-width: 768px) {
//         .category-buttons-scroll-wrap {
//           flex-wrap: wrap !important;
//           justify-content: center !important;
//           overflow-x: visible !important;
//         }
//       }

//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       /* Filter Panel Styles */
//       .filter-overlay {
//         position: fixed;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//         z-index: 1040;
//         visibility: hidden;
//         opacity: 0;
//         transition: opacity 0.3s ease, visibility 0.3s ease;
//       }
//       .filter-overlay.active {
//         visibility: visible;
//         opacity: 1;
//       }

//       .filter-panel-slide {
//         position: fixed;
//         top: 0;
//         left: -400px;
//         width: 380px;
//         max-width: 90%;
//         height: 100vh;
//         background: #ffffff;
//         z-index: 1050;
//         transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
//         padding: 24px 20px;
//         display: flex;
//         flex-direction: column;
//         box-shadow: 4px 0 30px rgba(0, 0, 0, 0.1);
//       }
//       .filter-panel-slide.active {
//         left: 0;
//       }

//       .filter-scroll-content {
//         flex: 1;
//         overflow-y: auto;
//         padding-bottom: 20px;
//       }
//       .filter-scroll-content::-webkit-scrollbar {
//         width: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-track {
//         background: #f1f1f1;
//         border-radius: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-thumb {
//         background: #ccc;
//         border-radius: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-thumb:hover {
//         background: #aaa;
//       }

//       /* Filter Button */
//       .filter-trigger-btn {
//         background: #fff;
//         border: 2px solid #5dc5fa;
//         color: #5dc5fa;
//         border-radius: 50px;
//         padding: 8px 20px;
//         font-weight: 600;
//         transition: all 0.3s ease;
//         display: inline-flex;
//         align-items: center;
//         gap: 8px;
//       }
//       .filter-trigger-btn:hover {
//         background: #5dc5fa;
//         color: #fff;
//         transform: translateY(-2px);
//         box-shadow: 0 4px 15px rgba(241, 114, 40, 0.3);
//       }

//       input[type="checkbox"] {
//         cursor: pointer;
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container { --bs-gutter-x: 0.5rem !important; }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//         .filter-panel-slide {
//           width: 100%;
//           max-width: 100%;
//           left: -100%;
//         }
//         .filter-panel-slide.active {
//           left: 0;
//         }
//       }
//     `}</style>
//   );

//   if (loading) {
//     return (
//       <div className="min-vh-100 py-4">
//         {structuralStyles}
//         <div className="container px-2">
//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
//               <div key={n} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-vh-100 py-4">
//       <ToastContainer position="top-center" autoClose={1500} />
//       {structuralStyles}

//       {/* Filter Panel */}
//       <FilterPanel />

//       <motion.div
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="text-center mb-4"
//       >
//         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
//         <p className="text-muted">Explore categories and add your favorites!</p>
//       </motion.div>

//       {/* Filter Button and Category Buttons */}
//       <div className="container mb-4">
//         <div className="d-flex flex-wrap align-items-center gap-3">
//           <button
//             className="filter-trigger-btn"
//             onClick={() => setShowFilterPanel(true)}
//           >
//             <FaFilter /> Filters
//             {selectedBrandFilters.length > 0 && (
//               <span className="badge bg-danger ms-1" style={{ fontSize: '10px' }}>
//                 {selectedBrandFilters.length}
//               </span>
//             )}
//           </button>

//           <div className="category-buttons-scroll-wrap gap-2 flex-grow-1">
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => handleClick("all")}
//               className="btn"
//               style={{
//                 backgroundColor: selectedCategory === "all" ? "#5dc5fa" : "#fff",
//                 color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
//                 border: "2px solid #5dc5fa",
//                 borderRadius: "50px",
//                 fontWeight: "600",
//                 padding: "8px 18px",
//                 cursor: "pointer",
//                 whiteSpace: "nowrap",
//                 fontSize: "13px"
//               }}
//             >
//               All ({getCategoryCount('all')})
//             </motion.button>

//             {categoriesWithCounts.map((category) => {
//               const isSelected = selectedCategory === category.id;
//               const count = getCategoryCount(category.id);

//               return (
//                 <motion.button
//                   key={category.id}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   onClick={() => handleClick(category.id)}
//                   className="btn"
//                   style={{
//                     backgroundColor: isSelected ? "#5dc5fa" : "#fff",
//                     color: isSelected ? "#fff" : "#5dc5fa",
//                     border: "2px solid #5dc5fa",
//                     borderRadius: "50px",
//                     fontWeight: "600",
//                     padding: "8px 18px",
//                     cursor: "pointer",
//                     whiteSpace: "nowrap",
//                     fontSize: "13px"
//                   }}
//                 >
//                   {category.name} ({count})
//                 </motion.button>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {filteredProducts.length === 0 ? (
//         <div className="container text-center py-5">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//           >
//             <img
//               src="/img/gallery/no-products.svg"
//               alt="No products found"
//               style={{ width: "200px", marginBottom: "20px" }}
//               onError={(e) => e.target.style.display = "none"}
//             />
//             <h3 className="text-muted mb-3">No products found</h3>
//             <p className="text-secondary">
//               {selectedBrandFilters.length > 0
//                 ? `No products available for selected brand${selectedBrandFilters.length > 1 ? 's' : ''}: ${selectedBrandFilters.join(', ')}`
//                 : "No products available at the moment."
//               }
//             </p>
//             {selectedBrandFilters.length > 0 && (
//               <button
//                 className="btn btn-outline-danger rounded-pill px-4 mt-3"
//                 onClick={clearAllFilters}
//               >
//                 Clear Filters
//               </button>
//             )}
//           </motion.div>
//         </div>
//       ) : (
//         <>
//           <div className="container px-2">
//             <motion.div
//               layout
//               className="row gy-4 justify-content-center product-grid-container"
//               initial="hidden"
//               animate="visible"
//               variants={{
//                 hidden: { opacity: 0, y: 20 },
//                 visible: {
//                   opacity: 1,
//                   y: 0,
//                   transition: { staggerChildren: 0.05 },
//                 },
//               }}
//             >
//               {currentData.map((product) => {
//                 const isSoldOut = product.stock === 0;
//                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

//                 return (
//                   <motion.div key={product.id} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                     <motion.div className="card h-100 border-0 premium-card-wrapper">
//                       <div>
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={() => !wishlistLoading && toggleWishlist(product)}
//                             style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", zIndex: 2 }}
//                           >
//                             {isInWishlist ? <FaHeart size={22} color="red" /> : <CiHeart size={22} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />}
//                           </div>

//                           <motion.img
//                             src={product.item_photo || logo}
//                             alt={product.title}
//                             className="symmetric-cover-img"
//                             onClick={() => navigate(`products/${product.id}`)}
//                             style={{ cursor: "pointer" }}
//                           />
//                         </div>

//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
//                             {product.title}
//                           </h6>
//                           <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px", flexWrap: "wrap" }}>
//                             <p
//                               className="old-price mb-0 mobile-price-size"
//                               style={{
//                                 textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{product.item_old_price || 0}
//                             </p>
//                             <p className="fw-semibold mb-0 mobile-price-size" style={{ fontSize: "0.83333rem" }}>
//                               ₹{product.item_new_price}
//                             </p>
//                             <p className="discount-badge mb-0 fw-bold" style={{ color: 'green', fontSize: '12px' }}>
//                               {product.discount_percentage}% OFF
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="w-100 mt-3">
//                         {cartItems[product.id] && !isSoldOut ? (
//                           <div className="d-flex justify-content-center align-items-center gap-2">
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => subOne(product.id)}>-</button>
//                             <span className="fw-bold text-dark mx-2">{cartItems[product.id]}</span>
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => addOne(product.id)}>+</button>
//                           </div>
//                         ) : (
//                           <motion.button
//                             whileHover={{ scale: 1.02 }}
//                             className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                             onClick={() => onPressAddToCart(product.id)}
//                             disabled={isSoldOut}
//                             style={{ backgroundColor: "#5dc5fa", border: "none", padding: "8px 0", fontSize: "13px" }}
//                           >
//                             Add to Cart
//                           </motion.button>
//                         )}
//                       </div>
//                     </motion.div>
//                   </motion.div>
//                 );
//               })}
//             </motion.div>

//             {totalPages > 1 && (
//               <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4, px: 2 }}>
//                 <StyledPagination
//                   count={totalPages}
//                   page={itemsPage}
//                   onChange={(event, value) => setItemsPage(value)}
//                   shape="rounded"
//                   color="primary"
//                   size="medium"
//                 />
//               </Stack>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Product;

// import React, { useEffect, useState, useRef } from "react";
// import { motion } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate, useLocation } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import axios from "axios";
// import "./Product.css";
// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
// import { styled } from "@mui/material/styles";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useWishlist } from "../../contexts/WishlistContext";
// import { FaFilter, FaTimes, FaChevronDown, FaChevronRight, FaSlidersH } from "react-icons/fa";

// const StyledPagination = styled(Pagination)(() => ({
//   "& .MuiPaginationItem-root": {
//     color: "#5dc5fa",
//     borderRadius: "50%",
//     fontWeight: "600",
//     transition: "all 0.3s ease",
//     "& :hover": {
//       backgroundColor: "#ffece4",
//       color: "#5dc5fa",
//       transform: "scale(1.1)",
//     },
//     minWidth: "25px",
//     height: "25px",
//     maxHeight: "32px",
//   },
//   "& .Mui-selected": {
//     backgroundColor: "#5dc5fa !important",
//     color: "#fff !important",
//     boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
//     transform: "scale(1.15)",
//   },
//   "& .MuiPagination-ul": {
//     gap: "8px",
//   },
// }));

// function Product({
//   refreshCart,
//   getProducts,
//   getAllProducts,
//   products,
//   categoriesWithCounts = [],
//   selectedBrands = [],
//   loading = false,
//   totalItems = 0,
//   brands = []
// }) {
//   const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage, setProducts } = useWishlist();
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();
//   const location = useLocation();
//   const pageSize = 12;

//   const hasRestored = useRef(false);

//   // Filter states
//   const [showFilterPanel, setShowFilterPanel] = useState(false);
//   const [expandedSections, setExpandedSections] = useState({
//     brands: true
//   });
//   const [selectedBrandFilters, setSelectedBrandFilters] = useState([]);
//   const [brandSearch, setBrandSearch] = useState("");
//   const [isFilterLoading, setIsFilterLoading] = useState(false);
  
//   // State for filtered category counts
//   const [filteredCategories, setFilteredCategories] = useState([]);
//   const [filteredTotal, setFilteredTotal] = useState(0);
//   const [isBrandFilterActive, setIsBrandFilterActive] = useState(false);

//   // Filter brands based on search
//   const filteredBrands = brands.filter(brand =>
//     brand.toLowerCase().includes(brandSearch.toLowerCase())
//   );

//   // Group filtered brands alphabetically
//   const groupedFilteredBrands = filteredBrands.reduce((groups, brand) => {
//     const firstLetter = brand.charAt(0).toUpperCase();
//     if (!groups[firstLetter]) {
//       groups[firstLetter] = [];
//     }
//     groups[firstLetter].push(brand);
//     return groups;
//   }, {});

//   const productsArray = Array.isArray(products) ? products : [];

//   // ✅ Use filtered products
//   const filteredProducts = productsArray;

//   // Use filtered counts if brand filter is active, otherwise use parent counts
//   const displayCategories = isBrandFilterActive && filteredCategories.length > 0 ? filteredCategories : categoriesWithCounts;
//   const displayTotal = isBrandFilterActive && filteredTotal > 0 ? filteredTotal : totalItems;

//   const totalPages = Math.ceil(filteredProducts.length / pageSize);

//   // Restore page from location state or sessionStorage
//   useEffect(() => {
//     if (location.state && location.state.returnPage) {
//       const returnPage = parseInt(location.state.returnPage);
//       if (returnPage > 0 && returnPage <= Math.max(totalPages, 1)) {
//         setItemsPage(returnPage);
//         hasRestored.current = true;
//         window.history.replaceState({}, document.title);
//         return;
//       }
//     }

//     if (!hasRestored.current) {
//       const savedPage = sessionStorage.getItem('productPage');
//       const savedCategory = sessionStorage.getItem('productCategory');

//       if (savedPage) {
//         const pageNum = parseInt(savedPage);
//         if (pageNum > 0 && pageNum <= Math.max(totalPages, 1)) {
//           setItemsPage(pageNum);
//           hasRestored.current = true;

//           if (savedCategory && savedCategory !== 'all') {
//             setSelectedCategory(savedCategory);
//           }

//           setTimeout(() => {
//             sessionStorage.removeItem('productPage');
//             sessionStorage.removeItem('productCategory');
//           }, 500);
//         }
//       }
//     }
//   }, [totalPages, location.state]);

//   useEffect(() => {
//     if (!hasRestored.current) {
//       sessionStorage.setItem('productPage', itemsPage.toString());
//       sessionStorage.setItem('productCategory', selectedCategory);
//     }
//   }, [itemsPage, selectedCategory]);

//   const currentData = filteredProducts.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

//   useEffect(() => {
//     getStock();
//     getCartItems();
//   }, []);

//   useEffect(() => {
//     setSelectedCategory("all");
//     setItemsPage(1);
//     if (selectedBrands && selectedBrands.length > 0) {
//       getAllProducts();
//     }
//   }, [selectedBrands]);

//   useEffect(() => {
//     setItemsPage(1);
//   }, [selectedBrands, productsArray]);

//   // ✅ Function to fetch category counts with brand filter (for ALL categories)
//   const fetchCategoryCountsWithBrand = async (brandParams) => {
//     try {
//       // Fetch all categories
//       const categoriesResponse = await axios.get('https://backend.frozenwala.com/api/auth/categories/');
//       const allCategories = categoriesResponse.data;
      
//       // Fetch ALL products with brand filter (not just one category)
//       const productsUrl = `https://backend.frozenwala.com/api/auth/product-all/?brand=${brandParams}`;
//       const productsResponse = await axios.get(productsUrl);
//       const allProductList = productsResponse.data?.products ?? [];
      
//       // Calculate category counts from ALL filtered products
//       const countsMap = {};
//       let total = 0;
      
//       allProductList.forEach(product => {
//         total++;
//         const catId = product.category;
//         if (catId) {
//           if (!countsMap[catId]) {
//             countsMap[catId] = { count: 0 };
//           }
//           countsMap[catId].count++;
//         }
//       });
      
//       // Update categories with counts from ALL products
//       const updatedCategories = allCategories.map(cat => ({
//         ...cat,
//         total_items: countsMap[cat.id] ? countsMap[cat.id].count : 0
//       }));
      
//       setFilteredCategories(updatedCategories);
//       setFilteredTotal(total);
//       setIsBrandFilterActive(true);
      
//       return { categories: updatedCategories, total, allProducts: allProductList };
//     } catch (error) {
//       console.error("Error fetching category counts with brand:", error);
//       return null;
//     }
//   };

//   // ✅ Function to fetch products for a specific category with brand filter
//   const fetchCategoryProductsWithBrand = async (brandParams, categoryId) => {
//     try {
//       const productsUrl = `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=${categoryId}&brand=${brandParams}`;
//       const productsResponse = await axios.get(productsUrl);
//       return productsResponse.data ?? [];
//     } catch (error) {
//       console.error("Error fetching category products with brand:", error);
//       return [];
//     }
//   };

//   // ✅ Handle category click with brand filters
//   const handleClick = async (categoryId) => {
//     setItemsPage(1);
//     setSelectedCategory(categoryId);
//     hasRestored.current = false;

//     if (selectedBrandFilters.length > 0) {
//       setIsFilterLoading(true);
//       const brandParams = selectedBrandFilters.map(b => encodeURIComponent(b)).join(',');
      
//       // Step 1: Fetch ALL products with brand filter to update category counts
//       const result = await fetchCategoryCountsWithBrand(brandParams);
      
//       if (result) {
//         // Step 2: If a specific category is selected, fetch products for that category only
//         if (categoryId !== "all") {
//           const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, categoryId);
//           setProducts(categoryProducts);
//         } else {
//           // If "All" is selected, show all products
//           setProducts(result.allProducts);
//         }
//       }
//       setIsFilterLoading(false);
//     } else {
//       // No brand filters, fetch normally
//       if (categoryId === "all") {
//         getAllProducts();
//         setIsBrandFilterActive(false);
//         setFilteredCategories([]);
//         setFilteredTotal(0);
//       } else {
//         getProducts(categoryId);
//         setIsBrandFilterActive(false);
//         setFilteredCategories([]);
//         setFilteredTotal(0);
//       }
//     }
//   };

//   const getCartItems = async () => {
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       const map = {};
//       response.data.forEach((item) => (map[item.product_id] = item.quantity));
//       setCartItems(map);
//     } catch (error) {
//       console.error("Error fetching cart items:", error);
//     }
//   };

//   const getStock = async () => {
//     try {
//       const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//       const map = {};
//       response.data.forEach((item) => (map[item.item_id] = item.openingstock));
//       setStock(map);
//     } catch (error) {
//       console.error("Error getting stock:", error);
//     }
//   };

//   const onPressAddToCart = async (productId) => {
//     const available = stock[productId];
//     if (available === 0) {
//       alert("No stock available");
//       return;
//     }
//     if (uid) {
//       try {
//         await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//         refreshCart();
//         setCartItems((prev) => ({
//           ...prev,
//           [productId]: (prev[productId] || 0) + 1,
//         }));
//       } catch (error) {
//         console.error("Error adding product:", error);
//       }
//     } else navigate("/login");
//   };

//   const addOne = async (productId) => {
//     const available = stock[productId];
//     const currentQty = cartItems[productId] || 0;
//     if (available > currentQty) {
//       await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//       refreshCart();
//     } else {
//       alert(`Only ${available} items available in stock.`);
//     }
//   };

//   const subOne = async (productId) => {
//     if (cartItems[productId] > 1) {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: prev[productId] - 1,
//       }));
//     }
//   };

//   // Filter handlers
//   const toggleSection = (section) => {
//     setExpandedSections(prev => ({
//       ...prev,
//       [section]: !prev[section]
//     }));
//   };

//   const handleBrandFilterChange = (brandName) => {
//     setSelectedBrandFilters(prev =>
//       prev.includes(brandName)
//         ? prev.filter(name => name !== brandName)
//         : [...prev, brandName]
//     );
//   };

//   const clearAllFilters = () => {
//     setSelectedBrandFilters([]);
//     setBrandSearch("");
//     setItemsPage(1);
//     setIsBrandFilterActive(false);
//     setFilteredCategories([]);
//     setFilteredTotal(0);
    
//     if (selectedCategory === "all") {
//       getAllProducts();
//     } else {
//       getProducts(selectedCategory);
//     }
//   };

//   // ✅ Apply filters with brand only
//   const applyFilters = async () => {
//     if (selectedBrandFilters.length === 0) {
//       setIsBrandFilterActive(false);
//       setFilteredCategories([]);
//       setFilteredTotal(0);
//       if (selectedCategory === "all") {
//         getAllProducts();
//       } else {
//         getProducts(selectedCategory);
//       }
//       toast.info("Showing all products");
//     } else {
//       setIsFilterLoading(true);
//       const brandParams = selectedBrandFilters.map(b => encodeURIComponent(b)).join(',');
      
//       // Fetch ALL products with brand filter to update counts
//       const result = await fetchCategoryCountsWithBrand(brandParams);
      
//       if (result) {
//         // If a specific category was previously selected, show products for that category
//         if (selectedCategory !== "all") {
//           const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, selectedCategory);
//           setProducts(categoryProducts);
//         } else {
//           // Show all products
//           setProducts(result.allProducts);
//         }
//         toast.success(`Filtered by ${selectedBrandFilters.length} brand${selectedBrandFilters.length > 1 ? 's' : ''}`);
//       }
      
//       setItemsPage(1);
//       setIsFilterLoading(false);
//     }
//     setShowFilterPanel(false);
//   };

//   // Remove a single brand filter and re-apply
//   const removeBrandFilter = async (brandToRemove) => {
//     const updatedBrands = selectedBrandFilters.filter(b => b !== brandToRemove);
//     setSelectedBrandFilters(updatedBrands);
    
//     setTimeout(async () => {
//       if (updatedBrands.length === 0) {
//         setIsBrandFilterActive(false);
//         setFilteredCategories([]);
//         setFilteredTotal(0);
//         if (selectedCategory === "all") {
//           getAllProducts();
//         } else {
//           getProducts(selectedCategory);
//         }
//       } else {
//         const brandParams = updatedBrands.map(b => encodeURIComponent(b)).join(',');
        
//         // Fetch ALL products with brand filter to update counts
//         const result = await fetchCategoryCountsWithBrand(brandParams);
        
//         if (result) {
//           // If a specific category was selected, show products for that category
//           if (selectedCategory !== "all") {
//             const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, selectedCategory);
//             setProducts(categoryProducts);
//           } else {
//             setProducts(result.allProducts);
//           }
//           setItemsPage(1);
//         }
//       }
//     }, 100);
//   };

//   // Filter Panel Component
//   const FilterPanel = () => (
//     <div
//       className={`filter-overlay ${showFilterPanel ? 'active' : ''}`}
//       onClick={() => setShowFilterPanel(false)}
//     >
//       <div
//         className={`filter-panel-slide ${showFilterPanel ? 'active' : ''}`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
//           <h5 className="fw-bold mb-0 d-flex align-items-center" style={{ color: '#333', fontSize: '18px' }}>
//             <FaSlidersH className="me-2" style={{ color: '#5dc5fa' }} />
//             Filters
//           </h5>
//           <div className="d-flex align-items-center gap-3">
//             <button
//               onClick={clearAllFilters}
//               className="btn btn-link text-decoration-none p-0"
//               style={{ color: '#5dc5fa', fontSize: '14px', fontWeight: '600' }}
//             >
//               Clear All
//             </button>
//             <button
//               className="btn p-0"
//               onClick={() => setShowFilterPanel(false)}
//             >
//               <FaTimes size={20} />
//             </button>
//           </div>
//         </div>

//         <div className="filter-scroll-content">
//           <div className="mb-3">
//             <div
//               className="d-flex justify-content-between align-items-center py-2"
//               style={{ cursor: 'pointer', borderBottom: '1px solid #f5f5f5' }}
//               onClick={() => toggleSection('brands')}
//             >
//               <span className="fw-bold" style={{ fontSize: '15px', color: '#333' }}>Brands</span>
//               {expandedSections.brands ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}
//             </div>
//             {expandedSections.brands && (
//               <div className="mt-2">
//                 <div className="mb-3">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search brands..."
//                     value={brandSearch}
//                     onChange={(e) => setBrandSearch(e.target.value)}
//                     style={{
//                       border: '1px solid #ddd',
//                       borderRadius: '8px',
//                       padding: '8px 12px',
//                       fontSize: '14px'
//                     }}
//                   />
//                 </div>

//                 {Object.keys(groupedFilteredBrands)
//                   .sort()
//                   .map((letter) => (
//                     <div key={letter} className="mb-3">
//                       <div
//                         style={{
//                           fontWeight: 700,
//                           fontSize: '13px',
//                           color: '#5dc5fa',
//                           borderBottom: '1px solid #eee',
//                           paddingBottom: '4px',
//                           marginBottom: '8px'
//                         }}
//                       >
//                         {letter}
//                       </div>
//                       {groupedFilteredBrands[letter].map((brand, idx) => (
//                         <div
//                           key={`${letter}-${idx}`}
//                           className="d-flex align-items-center py-1"
//                           style={{ cursor: 'pointer' }}
//                         >
//                           <input
//                             type="checkbox"
//                             id={`brand-${brand}`}
//                             checked={selectedBrandFilters.includes(brand)}
//                             onChange={() => handleBrandFilterChange(brand)}
//                             style={{ accentColor: '#5dc5fa', width: '18px', height: '18px' }}
//                           />
//                           <label
//                             htmlFor={`brand-${brand}`}
//                             className="ms-3 mb-0"
//                             style={{ fontSize: '14px', color: '#555', cursor: 'pointer' }}
//                           >
//                             {brand}
//                           </label>
//                         </div>
//                       ))}
//                     </div>
//                   ))}
//                 {Object.keys(groupedFilteredBrands).length === 0 && (
//                   <p className="text-muted small">No brands found</p>
//                 )}

//                 {selectedBrandFilters.length > 0 && (
//                   <div className="mt-2 p-2" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
//                     <span className="text-muted small">
//                       Selected: {selectedBrandFilters.length} brand{selectedBrandFilters.length > 1 ? 's' : ''}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           <button
//             onClick={applyFilters}
//             className="btn w-100 mt-3"
//             style={{
//               background: '#5dc5fa',
//               color: '#fff',
//               borderRadius: '10px',
//               padding: '12px',
//               fontWeight: '600',
//               border: 'none',
//               fontSize: '15px'
//             }}
//             disabled={isFilterLoading}
//           >
//             {isFilterLoading ? 'Applying...' : 'Apply Filters'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   // Styles
//   const structuralStyles = (
//     <style>{`
//       .category-buttons-scroll-wrap {
//         display: flex !important;
//         flex-wrap: nowrap !important;
//         overflow-x: auto !important;
//         -webkit-overflow-scrolling: touch;
//         padding-bottom: 8px;
//         justify-content: flex-start !important;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar {
//         height: 4px;
//       }
//       .category-buttons-scroll-wrap::-webkit-scrollbar-thumb {
//         background-color: #ffece4;
//         border-radius: 4px;
//       }
//       @media (min-width: 768px) {
//         .category-buttons-scroll-wrap {
//           flex-wrap: wrap !important;
//           justify-content: center !important;
//           overflow-x: visible !important;
//         }
//       }

//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       .filter-overlay {
//         position: fixed;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//         z-index: 1040;
//         visibility: hidden;
//         opacity: 0;
//         transition: opacity 0.3s ease, visibility 0.3s ease;
//       }
//       .filter-overlay.active {
//         visibility: visible;
//         opacity: 1;
//       }

//       .filter-panel-slide {
//         position: fixed;
//         top: 0;
//         left: -400px;
//         width: 380px;
//         max-width: 90%;
//         height: 100vh;
//         background: #ffffff;
//         z-index: 1050;
//         transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
//         padding: 24px 20px;
//         display: flex;
//         flex-direction: column;
//         box-shadow: 4px 0 30px rgba(0, 0, 0, 0.1);
//       }
//       .filter-panel-slide.active {
//         left: 0;
//       }

//       .filter-scroll-content {
//         flex: 1;
//         overflow-y: auto;
//         padding-bottom: 20px;
//       }
//       .filter-scroll-content::-webkit-scrollbar {
//         width: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-track {
//         background: #f1f1f1;
//         border-radius: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-thumb {
//         background: #ccc;
//         border-radius: 4px;
//       }
//       .filter-scroll-content::-webkit-scrollbar-thumb:hover {
//         background: #aaa;
//       }

//       .filter-trigger-btn {
//         background: #fff;
//         border: 2px solid #5dc5fa;
//         color: #5dc5fa;
//         border-radius: 50px;
//         padding: 8px 20px;
//         font-weight: 600;
//         transition: all 0.3s ease;
//         display: inline-flex;
//         align-items: center;
//         gap: 8px;
//       }
//       .filter-trigger-btn:hover {
//         background: #5dc5fa;
//         color: #fff;
//         transform: translateY(-2px);
//         box-shadow: 0 4px 15px rgba(241, 114, 40, 0.3);
//       }

//       input[type="checkbox"] {
//         cursor: pointer;
//       }

//       .brand-filter-badge {
//         background: #f0f0f0;
//         border-radius: 20px;
//         padding: 4px 12px;
//         font-size: 12px;
//         display: inline-flex;
//         align-items: center;
//         gap: 6px;
//         border: 1px solid #ddd;
//       }
//       .brand-filter-badge .remove-btn {
//         cursor: pointer;
//         color: #999;
//         transition: color 0.2s;
//       }
//       .brand-filter-badge .remove-btn:hover {
//         color: #5dc5fa;
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container { --bs-gutter-x: 0.5rem !important; }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//         .filter-panel-slide {
//           width: 100%;
//           max-width: 100%;
//           left: -100%;
//         }
//         .filter-panel-slide.active {
//           left: 0;
//         }
//       }
//     `}</style>
//   );

//   if (loading || isFilterLoading) {
//     return (
//       <div className="min-vh-100 py-4">
//         {structuralStyles}
//         <div className="container px-2">
//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
//               <div key={n} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-vh-100 py-4">
//       <ToastContainer position="top-center" autoClose={1500} />
//       {structuralStyles}

//       <FilterPanel />

//       <motion.div
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.6 }}
//         className="text-center mb-4"
//       >
//         <h2 className="fw-bold text-danger">Our Delicious Products</h2>
//         <p className="text-muted">Explore categories and add your favorites!</p>
//       </motion.div>

//       <div className="container mb-4">
//         <div className="d-flex flex-wrap align-items-center gap-3">
//           <button
//             className="filter-trigger-btn"
//             onClick={() => setShowFilterPanel(true)}
//           >
//             <FaFilter /> Filters
//             {selectedBrandFilters.length > 0 && (
//               <span className="badge bg-danger ms-1" style={{ fontSize: '10px' }}>
//                 {selectedBrandFilters.length}
//               </span>
//             )}
//           </button>

//           <div className="category-buttons-scroll-wrap gap-2 flex-grow-1">
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => handleClick("all")}
//               className="btn"
//               style={{
//                 backgroundColor: selectedCategory === "all" ? "#5dc5fa" : "#fff",
//                 color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
//                 border: "2px solid #5dc5fa",
//                 borderRadius: "50px",
//                 fontWeight: "600",
//                 padding: "8px 18px",
//                 cursor: "pointer",
//                 whiteSpace: "nowrap",
//                 fontSize: "13px"
//               }}
//             >
//               All ({displayTotal})
//             </motion.button>

//             {displayCategories.map((category) => {
//               const isSelected = selectedCategory === category.id;
//               const count = category.total_items ?? 0;

//               return (
//                 <motion.button
//                   key={category.id}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   onClick={() => handleClick(category.id)}
//                   className="btn"
//                   style={{
//                     backgroundColor: isSelected ? "#5dc5fa" : "#fff",
//                     color: isSelected ? "#fff" : "#5dc5fa",
//                     border: "2px solid #5dc5fa",
//                     borderRadius: "50px",
//                     fontWeight: "600",
//                     padding: "8px 18px",
//                     cursor: "pointer",
//                     whiteSpace: "nowrap",
//                     fontSize: "13px"
//                   }}
//                 >
//                   {category.name} ({count})
//                 </motion.button>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {filteredProducts.length === 0 ? (
//         <div className="container text-center py-5">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//           >
//             <img
//               src="/img/gallery/no-products.svg"
//               alt="No products found"
//               style={{ width: "200px", marginBottom: "20px" }}
//               onError={(e) => e.target.style.display = "none"}
//             />
//             <h3 className="text-muted mb-3">No products found</h3>
//             <p className="text-secondary">
//               {selectedBrandFilters.length > 0
//                 ? `No products available for selected brand${selectedBrandFilters.length > 1 ? 's' : ''}: ${selectedBrandFilters.join(', ')}`
//                 : "No products available at the moment."
//               }
//             </p>
//             {selectedBrandFilters.length > 0 && (
//               <button
//                 className="btn btn-outline-danger rounded-pill px-4 mt-3"
//                 onClick={clearAllFilters}
//               >
//                 Clear Filters
//               </button>
//             )}
//           </motion.div>
//         </div>
//       ) : (
//         <>
//           <div className="container px-2">
//             <motion.div
//               layout
//               className="row gy-4 justify-content-center product-grid-container"
//               initial="hidden"
//               animate="visible"
//               variants={{
//                 hidden: { opacity: 0, y: 20 },
//                 visible: {
//                   opacity: 1,
//                   y: 0,
//                   transition: { staggerChildren: 0.05 },
//                 },
//               }}
//             >
//               {currentData.map((product) => {
//                 const isSoldOut = product.stock === 0;
//                 const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

//                 return (
//                   <motion.div key={product.id} className="col-6 col-sm-6 col-md-4 col-lg-3">
//                     <motion.div className="card h-100 border-0 premium-card-wrapper">
//                       <div>
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={() => !wishlistLoading && toggleWishlist(product)}
//                             style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", zIndex: 2 }}
//                           >
//                             {isInWishlist ? <FaHeart size={22} color="red" /> : <CiHeart size={22} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />}
//                           </div>

//                           <motion.img
//                             src={product.item_photo || logo}
//                             alt={product.title}
//                             className="symmetric-cover-img"
//                             onClick={() => {
//                               const pageToReturn = itemsPage;
//                               navigate(`/products/${product.id}`, {
//                                 state: { returnPage: pageToReturn }
//                               });
//                             }}
//                             style={{ cursor: "pointer" }}
//                           />
//                         </div>

//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
//                             {product.title}
//                           </h6>
//                           <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px", flexWrap: "wrap" }}>
//                             <p
//                               className="old-price mb-0 mobile-price-size"
//                               style={{
//                                 textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{product.item_old_price || 0}
//                             </p>
//                             <p className="fw-semibold mb-0 mobile-price-size" style={{ fontSize: "0.83333rem" }}>
//                               ₹{product.item_new_price}
//                             </p>
//                             <p className="discount-badge mb-0 fw-bold" style={{ color: 'green', fontSize: '12px' }}>
//                               {product.discount_percentage}% OFF
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="w-100 mt-3">
//                         {cartItems[product.id] && !isSoldOut ? (
//                           <div className="d-flex justify-content-center align-items-center gap-2">
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => subOne(product.id)}>-</button>
//                             <span className="fw-bold text-dark mx-2">{cartItems[product.id]}</span>
//                             <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => addOne(product.id)}>+</button>
//                           </div>
//                         ) : (
//                           <motion.button
//                             whileHover={{ scale: 1.02 }}
//                             className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                             onClick={() => onPressAddToCart(product.id)}
//                             disabled={isSoldOut}
//                             style={{ backgroundColor: "#5dc5fa", border: "none", padding: "8px 0", fontSize: "13px" }}
//                           >
//                             Add to Cart
//                           </motion.button>
//                         )}
//                       </div>
//                     </motion.div>
//                   </motion.div>
//                 );
//               })}
//             </motion.div>

//             {totalPages > 1 && (
//               <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4, px: 2 }}>
//                 <StyledPagination
//                   count={totalPages}
//                   page={itemsPage}
//                   onChange={(event, value) => {
//                     setItemsPage(value);
//                     sessionStorage.setItem('productPage', value.toString());
//                     sessionStorage.setItem('productCategory', selectedCategory);
//                   }}
//                   shape="rounded"
//                   color="primary"
//                   size="medium"
//                 />
//               </Stack>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Product;

import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import Api from "../Utills/Api";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../Frozenwala.png";
import axios from "axios";
import "./Product.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useWishlist } from "../../contexts/WishlistContext";
import { FaFilter, FaTimes, FaChevronDown, FaChevronRight, FaSlidersH } from "react-icons/fa";
import ProductModal from "./ProductModal";

const StyledPagination = styled(Pagination)(() => ({
  "& .MuiPaginationItem-root": {
    color: "#5dc5fa",
    borderRadius: "50%",
    fontWeight: "600",
    transition: "all 0.3s ease",
    "& :hover": {
      backgroundColor: "#ffece4",
      color: "#5dc5fa",
      transform: "scale(1.1)",
    },
    minWidth: "25px",
    height: "25px",
    maxHeight: "32px",
  },
  "& .Mui-selected": {
    backgroundColor: "#5dc5fa !important",
    color: "#fff !important",
    boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
    transform: "scale(1.15)",
  },
  "& .MuiPagination-ul": {
    gap: "8px",
  },
}));

function Product({
  refreshCart,
  getProducts,
  getAllProducts,
  products,
  categoriesWithCounts = [],
  selectedBrands = [],
  loading = false,
  totalItems = 0,
  brands = []
}) {
  const { wishlist, toggleWishlist, wishlistLoading, itemsPage, setItemsPage, setProducts } = useWishlist();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});
  const uid = localStorage.getItem("user_id");
  const navigate = useNavigate();
  const location = useLocation();
  const pageSize = 12;

  const hasRestored = useRef(false);

  // Modal states
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Filter states
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    brands: true
  });
  const [selectedBrandFilters, setSelectedBrandFilters] = useState([]);
  const [brandSearch, setBrandSearch] = useState("");
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  
  // State for filtered category counts
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const [isBrandFilterActive, setIsBrandFilterActive] = useState(false);

  // Filter brands based on search
  const filteredBrands = brands.filter(brand =>
    brand.toLowerCase().includes(brandSearch.toLowerCase())
  );

  // Group filtered brands alphabetically
  const groupedFilteredBrands = filteredBrands.reduce((groups, brand) => {
    const firstLetter = brand.charAt(0).toUpperCase();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(brand);
    return groups;
  }, {});

  const productsArray = Array.isArray(products) ? products : [];

  // ✅ Use filtered products
  const filteredProducts = productsArray;

  // Use filtered counts if brand filter is active, otherwise use parent counts
  const displayCategories = isBrandFilterActive && filteredCategories.length > 0 ? filteredCategories : categoriesWithCounts;
  const displayTotal = isBrandFilterActive && filteredTotal > 0 ? filteredTotal : totalItems;

  const totalPages = Math.ceil(filteredProducts.length / pageSize);

  // Reset brand filter state when category changes
useEffect(() => {
  // Clear brand filter active state when category changes manually
  if (selectedCategory !== "all") {
    // Keep brand filters if they exist, but ensure UI updates
    if (selectedBrandFilters.length === 0) {
      setIsBrandFilterActive(false);
    }
  }
}, [selectedCategory]);

  // Restore page from location state or sessionStorage
  useEffect(() => {
    if (location.state && location.state.returnPage) {
      const returnPage = parseInt(location.state.returnPage);
      if (returnPage > 0 && returnPage <= Math.max(totalPages, 1)) {
        setItemsPage(returnPage);
        hasRestored.current = true;
        window.history.replaceState({}, document.title);
        return;
      }
    }

    if (!hasRestored.current) {
      const savedPage = sessionStorage.getItem('productPage');
      const savedCategory = sessionStorage.getItem('productCategory');

      if (savedPage) {
        const pageNum = parseInt(savedPage);
        if (pageNum > 0 && pageNum <= Math.max(totalPages, 1)) {
          setItemsPage(pageNum);
          hasRestored.current = true;

          if (savedCategory && savedCategory !== 'all') {
            setSelectedCategory(savedCategory);
          }

          setTimeout(() => {
            sessionStorage.removeItem('productPage');
            sessionStorage.removeItem('productCategory');
          }, 500);
        }
      }
    }
  }, [totalPages, location.state]);

  useEffect(() => {
    if (!hasRestored.current) {
      sessionStorage.setItem('productPage', itemsPage.toString());
      sessionStorage.setItem('productCategory', selectedCategory);
    }
  }, [itemsPage, selectedCategory]);

  const currentData = filteredProducts.slice((itemsPage - 1) * pageSize, itemsPage * pageSize);

  useEffect(() => {
    getStock();
    getCartItems();
  }, []);

  useEffect(() => {
    setSelectedCategory("all");
    setItemsPage(1);
    if (selectedBrands && selectedBrands.length > 0) {
      getAllProducts();
    }
  }, [selectedBrands]);

  useEffect(() => {
    setItemsPage(1);
  }, [selectedBrands, productsArray]);

  // ✅ Function to fetch category counts with brand filter (for ALL categories)
  const fetchCategoryCountsWithBrand = async (brandParams) => {
    try {
      // Fetch all categories
      const categoriesResponse = await axios.get('https://backend.frozenwala.com/api/auth/categories/');
      const allCategories = categoriesResponse.data;
      
      // Fetch ALL products with brand filter (not just one category)
      const productsUrl = `https://backend.frozenwala.com/api/auth/product-all/?brand=${brandParams}`;
      const productsResponse = await axios.get(productsUrl);
      const allProductList = productsResponse.data?.products ?? [];
      
      // Calculate category counts from ALL filtered products
      const countsMap = {};
      let total = 0;
      
      allProductList.forEach(product => {
        total++;
        const catId = product.category;
        if (catId) {
          if (!countsMap[catId]) {
            countsMap[catId] = { count: 0 };
          }
          countsMap[catId].count++;
        }
      });
      
      // Update categories with counts from ALL products
      const updatedCategories = allCategories.map(cat => ({
        ...cat,
        total_items: countsMap[cat.id] ? countsMap[cat.id].count : 0
      }));
      
      setFilteredCategories(updatedCategories);
      setFilteredTotal(total);
      setIsBrandFilterActive(true);
      
      return { categories: updatedCategories, total, allProducts: allProductList };
    } catch (error) {
      console.error("Error fetching category counts with brand:", error);
      return null;
    }
  };

  // ✅ Function to fetch products for a specific category with brand filter
  const fetchCategoryProductsWithBrand = async (brandParams, categoryId) => {
    try {
      const productsUrl = `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=${categoryId}&brand=${brandParams}`;
      const productsResponse = await axios.get(productsUrl);
      return productsResponse.data ?? [];
    } catch (error) {
      console.error("Error fetching category products with brand:", error);
      return [];
    }
  };

  // // ✅ Handle category click with brand filters
  // const handleClick = async (categoryId) => {
  //   setItemsPage(1);
  //   setSelectedCategory(categoryId);
  //   hasRestored.current = false;

  //   if (selectedBrandFilters.length > 0) {
  //     setIsFilterLoading(true);
  //     const brandParams = selectedBrandFilters.map(b => encodeURIComponent(b)).join(',');
      
  //     // Step 1: Fetch ALL products with brand filter to update category counts
  //     const result = await fetchCategoryCountsWithBrand(brandParams);
      
  //     if (result) {
  //       // Step 2: If a specific category is selected, fetch products for that category only
  //       if (categoryId !== "all") {
  //         const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, categoryId);
  //         setProducts(categoryProducts);
  //       } else {
  //         // If "All" is selected, show all products
  //         setProducts(result.allProducts);
  //       }
  //     }
  //     setIsFilterLoading(false);
  //   } else {
  //     // No brand filters, fetch normally
  //     if (categoryId === "all") {
  //       getAllProducts();
  //       setIsBrandFilterActive(false);
  //       setFilteredCategories([]);
  //       setFilteredTotal(0);
  //     } else {
  //       getProducts(categoryId);
  //       setIsBrandFilterActive(false);
  //       setFilteredCategories([]);
  //       setFilteredTotal(0);
  //     }
  //   }
  // };

// ✅ Handle category click with brand filters - COMPLETE FIX
const handleClick = async (categoryId) => {
  // Convert to string for consistent comparison
  const categoryIdStr = String(categoryId);
  
  // IMMEDIATELY update selected category for visual feedback
  setSelectedCategory(categoryIdStr);
  setItemsPage(1);
  hasRestored.current = false;

  // Clear any previous filter state
  setIsBrandFilterActive(false);
  
  // Store the category ID for later use
  const targetCategory = categoryIdStr;

  if (selectedBrandFilters.length > 0) {
    setIsFilterLoading(true);
    const brandParams = selectedBrandFilters.map(b => encodeURIComponent(b)).join(',');
    
    try {
      // Fetch ALL products with brand filter to update category counts
      const result = await fetchCategoryCountsWithBrand(brandParams);
      
      if (result) {
        // If a specific category is selected, fetch products for that category only
        if (targetCategory !== "all") {
          const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, targetCategory);
          setProducts(categoryProducts);
        } else {
          // If "All" is selected, show all products
          setProducts(result.allProducts);
        }
        
        // Mark that brand filter is active
        setIsBrandFilterActive(true);
      }
    } catch (error) {
      console.error("Error applying brand filters:", error);
    } finally {
      setIsFilterLoading(false);
    }
  } else {
    // No brand filters, fetch normally
    if (targetCategory === "all") {
      getAllProducts();
      setFilteredCategories([]);
      setFilteredTotal(0);
    } else {
      getProducts(targetCategory);
      setFilteredCategories([]);
      setFilteredTotal(0);
    }
  }
};

  const getCartItems = async () => {
    try {
      const response = await Api.get(`api/get_cart/?user_id=${uid}`);
      const map = {};
      response.data.forEach((item) => (map[item.product_id] = item.quantity));
      setCartItems(map);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const getStock = async () => {
    try {
      const response = await axios.get(`https://backend.frozenwala.com/api/stock/`);
      const map = {};
      response.data.forEach((item) => (map[item.item_id] = item.openingstock));
      setStock(map);
    } catch (error) {
      console.error("Error getting stock:", error);
    }
  };

  const onPressAddToCart = async (productId) => {
    const available = stock[productId];
    if (available === 0) {
      alert("No stock available");
      return;
    }
    if (uid) {
      try {
        await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
        refreshCart();
        setCartItems((prev) => ({
          ...prev,
          [productId]: (prev[productId] || 0) + 1,
        }));
      } catch (error) {
        console.error("Error adding product:", error);
      }
    } else navigate("/login");
  };

  const addOne = async (productId) => {
    const available = stock[productId];
    const currentQty = cartItems[productId] || 0;
    if (available > currentQty) {
      await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
      refreshCart();
    } else {
      alert(`Only ${available} items available in stock.`);
    }
  };

  const subOne = async (productId) => {
    if (cartItems[productId] > 1) {
      await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => ({
        ...prev,
        [productId]: prev[productId] - 1,
      }));
    }
  };

  // Filter handlers
  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleBrandFilterChange = (brandName) => {
    setSelectedBrandFilters(prev =>
      prev.includes(brandName)
        ? prev.filter(name => name !== brandName)
        : [...prev, brandName]
    );
  };

  const clearAllFilters = () => {
    setSelectedBrandFilters([]);
    setBrandSearch("");
    setItemsPage(1);
    setIsBrandFilterActive(false);
    setFilteredCategories([]);
    setFilteredTotal(0);
    
    if (selectedCategory === "all") {
      getAllProducts();
    } else {
      getProducts(selectedCategory);
    }
  };

  // ✅ Apply filters with brand only
  const applyFilters = async () => {
    if (selectedBrandFilters.length === 0) {
      setIsBrandFilterActive(false);
      setFilteredCategories([]);
      setFilteredTotal(0);
      if (selectedCategory === "all") {
        getAllProducts();
      } else {
        getProducts(selectedCategory);
      }
      toast.info("Showing all products");
    } else {
      setIsFilterLoading(true);
      const brandParams = selectedBrandFilters.map(b => encodeURIComponent(b)).join(',');
      
      // Fetch ALL products with brand filter to update counts
      const result = await fetchCategoryCountsWithBrand(brandParams);
      
      if (result) {
        // If a specific category was previously selected, show products for that category
        if (selectedCategory !== "all") {
          const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, selectedCategory);
          setProducts(categoryProducts);
        } else {
          // Show all products
          setProducts(result.allProducts);
        }
        toast.success(`Filtered by ${selectedBrandFilters.length} brand${selectedBrandFilters.length > 1 ? 's' : ''}`);
      }
      
      setItemsPage(1);
      setIsFilterLoading(false);
    }
    setShowFilterPanel(false);
  };

  // Remove a single brand filter and re-apply
  const removeBrandFilter = async (brandToRemove) => {
    const updatedBrands = selectedBrandFilters.filter(b => b !== brandToRemove);
    setSelectedBrandFilters(updatedBrands);
    
    setTimeout(async () => {
      if (updatedBrands.length === 0) {
        setIsBrandFilterActive(false);
        setFilteredCategories([]);
        setFilteredTotal(0);
        if (selectedCategory === "all") {
          getAllProducts();
        } else {
          getProducts(selectedCategory);
        }
      } else {
        const brandParams = updatedBrands.map(b => encodeURIComponent(b)).join(',');
        
        // Fetch ALL products with brand filter to update counts
        const result = await fetchCategoryCountsWithBrand(brandParams);
        
        if (result) {
          // If a specific category was selected, show products for that category
          if (selectedCategory !== "all") {
            const categoryProducts = await fetchCategoryProductsWithBrand(brandParams, selectedCategory);
            setProducts(categoryProducts);
          } else {
            setProducts(result.allProducts);
          }
          setItemsPage(1);
        }
      }
    }, 100);
  };

  // Handle product click - open modal
  const handleProductClick = (productId) => {
    setSelectedProductId(productId);
    setIsModalOpen(true);
  };

  // Close modal handler
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProductId(null);
  };

  // Filter Panel Component
// Move FilterPanel outside of Product component
const FilterPanel = ({
  showFilterPanel,
  setShowFilterPanel,
  expandedSections,
  toggleSection,
  brandSearch,
  setBrandSearch,
  groupedFilteredBrands,
  selectedBrandFilters,
  handleBrandFilterChange,
  clearAllFilters,
  applyFilters,
  isFilterLoading
}) => (
  <div
    className={`filter-overlay ${showFilterPanel ? 'active' : ''}`}
    onClick={() => setShowFilterPanel(false)}
  >
    <div
      className={`filter-panel-slide ${showFilterPanel ? 'active' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="d-flex justify-content-between align-items-center mb-3 pb-3" style={{ borderBottom: '1px solid #eee' }}>
        <h5 className="fw-bold mb-0 d-flex align-items-center" style={{ color: '#333', fontSize: '18px' }}>
          <FaSlidersH className="me-2" style={{ color: '#5dc5fa' }} />
          Filters
        </h5>
        <div className="d-flex align-items-center gap-3">
          <button
            onClick={clearAllFilters}
            className="btn btn-link text-decoration-none p-0"
            style={{ color: '#5dc5fa', fontSize: '14px', fontWeight: '600' }}
          >
            Clear All
          </button>
          <button
            className="btn p-0"
            onClick={() => setShowFilterPanel(false)}
          >
            <FaTimes size={20} />
          </button>
        </div>
      </div>

      <div className="filter-scroll-content">
        <div className="mb-3">
          <div
            className="d-flex justify-content-between align-items-center py-2"
            style={{ cursor: 'pointer', borderBottom: '1px solid #f5f5f5' }}
            onClick={() => toggleSection('brands')}
          >
            <span className="fw-bold" style={{ fontSize: '15px', color: '#333' }}>Brands</span>
            {expandedSections.brands ? <FaChevronDown size={14} /> : <FaChevronRight size={14} />}
          </div>
          {expandedSections.brands && (
            <div className="mt-2">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search brands..."
                  value={brandSearch}
                  onChange={(e) => setBrandSearch(e.target.value)}
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    fontSize: '14px'
                  }}
                  // Add autoFocus to keep focus on input
                  ref={(input) => {
                    if (input && showFilterPanel) {
                      setTimeout(() => input.focus(), 0);
                    }
                  }}
                />
              </div>

              {Object.keys(groupedFilteredBrands)
                .sort()
                .map((letter) => (
                  <div key={letter} className="mb-3">
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: '13px',
                        color: '#5dc5fa',
                        borderBottom: '1px solid #eee',
                        paddingBottom: '4px',
                        marginBottom: '8px'
                      }}
                    >
                      {letter}
                    </div>
                    {groupedFilteredBrands[letter].map((brand, idx) => (
                      <div
                        key={`${letter}-${idx}`}
                        className="d-flex align-items-center py-1"
                        style={{ cursor: 'pointer' }}
                      >
                        <input
                          type="checkbox"
                          id={`brand-${brand}`}
                          checked={selectedBrandFilters.includes(brand)}
                          onChange={() => handleBrandFilterChange(brand)}
                          style={{ accentColor: '#5dc5fa', width: '18px', height: '18px' }}
                        />
                        <label
                          htmlFor={`brand-${brand}`}
                          className="ms-3 mb-0"
                          style={{ fontSize: '14px', color: '#555', cursor: 'pointer' }}
                        >
                          {brand}
                        </label>
                      </div>
                    ))}
                  </div>
                ))}
              {Object.keys(groupedFilteredBrands).length === 0 && (
                <p className="text-muted small">No brands found</p>
              )}

              {selectedBrandFilters.length > 0 && (
                <div className="mt-2 p-2" style={{ background: '#f8f9fa', borderRadius: '8px' }}>
                  <span className="text-muted small">
                    Selected: {selectedBrandFilters.length} brand{selectedBrandFilters.length > 1 ? 's' : ''}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        <button
          onClick={applyFilters}
          className="btn w-100 mt-3"
          style={{
            background: '#5dc5fa',
            color: '#fff',
            borderRadius: '10px',
            padding: '12px',
            fontWeight: '600',
            border: 'none',
            fontSize: '15px'
          }}
          disabled={isFilterLoading}
        >
          {isFilterLoading ? 'Applying...' : 'Apply Filters'}
        </button>
      </div>
    </div>
  </div>
);

  // Styles
  const structuralStyles = (
    <style>{`
      .category-buttons-scroll-wrap {
        display: flex !important;
        flex-wrap: nowrap !important;
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 8px;
        justify-content: flex-start !important;
      }
      .category-buttons-scroll-wrap::-webkit-scrollbar {
        height: 4px;
      }
      .category-buttons-scroll-wrap::-webkit-scrollbar-thumb {
        background-color: #ffece4;
        border-radius: 4px;
      }
      @media (min-width: 768px) {
        .category-buttons-scroll-wrap {
          flex-wrap: wrap !important;
          justify-content: center !important;
          overflow-x: visible !important;
        }
      }

      .premium-card-wrapper {
        border-radius: 20px !important;
        padding: 12px !important;
        background: #ffffff !important;
        border: 1px solid rgba(0, 0, 0, 0.03) !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
        transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .premium-card-wrapper:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
      }
      .symmetric-image-frame {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        border-radius: 14px !important;
        background-color: #f7f7f7;
      }
      .symmetric-cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover !important;
        transition: transform 0.3s ease;
        cursor: pointer;
      }
      .premium-card-wrapper:hover .symmetric-cover-img {
        transform: scale(1.04);
      }

      .filter-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1040;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }
      .filter-overlay.active {
        visibility: visible;
        opacity: 1;
      }

      .filter-panel-slide {
        position: fixed;
        top: 0;
        left: -400px;
        width: 380px;
        max-width: 90%;
        height: 100vh;
        background: #ffffff;
        z-index: 1050;
        transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 24px 20px;
        display: flex;
        flex-direction: column;
        box-shadow: 4px 0 30px rgba(0, 0, 0, 0.1);
      }
      .filter-panel-slide.active {
        left: 0;
      }

      .filter-scroll-content {
        flex: 1;
        overflow-y: auto;
        padding-bottom: 20px;
      }
      .filter-scroll-content::-webkit-scrollbar {
        width: 4px;
      }
      .filter-scroll-content::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }
      .filter-scroll-content::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 4px;
      }
      .filter-scroll-content::-webkit-scrollbar-thumb:hover {
        background: #aaa;
      }

      .filter-trigger-btn {
        background: #fff;
        border: 2px solid #5dc5fa;
        color: #5dc5fa;
        border-radius: 50px;
        padding: 8px 20px;
        font-weight: 600;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 8px;
      }
      .filter-trigger-btn:hover {
        background: #5dc5fa;
        color: #fff;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(241, 114, 40, 0.3);
      }

      input[type="checkbox"] {
        cursor: pointer;
      }

      .brand-filter-badge {
        background: #f0f0f0;
        border-radius: 20px;
        padding: 4px 12px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        border: 1px solid #ddd;
      }
      .brand-filter-badge .remove-btn {
        cursor: pointer;
        color: #999;
        transition: color 0.2s;
      }
      .brand-filter-badge .remove-btn:hover {
        color: #5dc5fa;
      }

      .modal-trigger-area {
        cursor: pointer;
      }

      @media (max-width: 575.98px) {
        .product-grid-container { --bs-gutter-x: 0.5rem !important; }
        .premium-card-wrapper {
          padding: 8px !important;
          border-radius: 16px !important;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
        }
        .symmetric-image-frame {
          height: 135px;
          border-radius: 10px !important;
        }
        .mobile-title-size {
          font-size: 13px !important;
        }
        .mobile-price-size {
          font-size: 12px !important;
        }
        .filter-panel-slide {
          width: 100%;
          max-width: 100%;
          left: -100%;
        }
        .filter-panel-slide.active {
          left: 0;
        }
      }
    `}</style>
  );

  if (loading || isFilterLoading) {
    return (
      <div className="min-vh-100 py-4">
        {structuralStyles}
        <div className="container px-2">
          <div className="row gy-4 justify-content-center product-grid-container">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
              <div key={n} className="col-6 col-sm-6 col-md-4 col-lg-3">
                <div className="card h-100 border-0 premium-card-wrapper">
                  <div className="symmetric-image-frame skeleton-block" />
                  <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
                    <div className="skeleton-block skeleton-title" />
                    <div className="skeleton-block skeleton-meta" />
                    <div className="mt-auto w-100">
                      <div className="skeleton-block skeleton-btn" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 py-4">
      <ToastContainer position="top-center" autoClose={1500} />
      {structuralStyles}

<FilterPanel 
  showFilterPanel={showFilterPanel}
  setShowFilterPanel={setShowFilterPanel}
  expandedSections={expandedSections}
  toggleSection={toggleSection}
  brandSearch={brandSearch}
  setBrandSearch={setBrandSearch}
  groupedFilteredBrands={groupedFilteredBrands}
  selectedBrandFilters={selectedBrandFilters}
  handleBrandFilterChange={handleBrandFilterChange}
  clearAllFilters={clearAllFilters}
  applyFilters={applyFilters}
  isFilterLoading={isFilterLoading}
/>

      {/* Product Modal */}
      <ProductModal
        isOpen={isModalOpen}
        productId={selectedProductId}
        onClose={handleCloseModal}
        refreshCart={refreshCart}
      />

      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-4"
      >
        <h2 className="fw-bold text-danger">Our Delicious Products</h2>
        <p className="text-muted">Explore categories and add your favorites!</p>
      </motion.div>

      <div className="container mb-4">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <button
            className="filter-trigger-btn"
            onClick={() => setShowFilterPanel(true)}
          >
            <FaFilter /> Filters
            {selectedBrandFilters.length > 0 && (
              <span className="badge bg-danger ms-1" style={{ fontSize: '10px' }}>
                {selectedBrandFilters.length}
              </span>
            )}
          </button>

        <div className="category-buttons-scroll-wrap gap-2 flex-grow-1">
  <motion.button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={() => handleClick("all")}
    className="btn"
    style={{
      backgroundColor: selectedCategory === "all" || selectedCategory === "all" ? "#5dc5fa" : "#fff",
      color: selectedCategory === "all" ? "#fff" : "#5dc5fa",
      border: "2px solid #5dc5fa",
      borderRadius: "50px",
      fontWeight: "600",
      padding: "8px 18px",
      cursor: "pointer",
      whiteSpace: "nowrap",
      fontSize: "13px"
    }}
  >
    All ({displayTotal})
  </motion.button>

  {displayCategories.map((category) => {
    // Convert both to strings for reliable comparison
    const isSelected = String(selectedCategory) === String(category.id);
    const count = category.total_items ?? 0;

    return (
      <motion.button
        key={category.id}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => handleClick(category.id)}
        className="btn"
        style={{
          backgroundColor: isSelected ? "#5dc5fa" : "#fff",
          color: isSelected ? "#fff" : "#5dc5fa",
          border: "2px solid #5dc5fa",
          borderRadius: "50px",
          fontWeight: "600",
          padding: "8px 18px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          fontSize: "13px"
        }}
      >
        {category.name} ({count})
      </motion.button>
    );
  })}
</div>
        </div>
      </div>

      {filteredProducts.length === 0 ? (
        <div className="container text-center py-5">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <img
              src="/img/gallery/no-products.svg"
              alt="No products found"
              style={{ width: "200px", marginBottom: "20px" }}
              onError={(e) => e.target.style.display = "none"}
            />
            <h3 className="text-muted mb-3">No products found</h3>
            <p className="text-secondary">
              {selectedBrandFilters.length > 0
                ? `No products available for selected brand${selectedBrandFilters.length > 1 ? 's' : ''}: ${selectedBrandFilters.join(', ')}`
                : "No products available at the moment."
              }
            </p>
            {selectedBrandFilters.length > 0 && (
              <button
                className="btn btn-outline-danger rounded-pill px-4 mt-3"
                onClick={clearAllFilters}
              >
                Clear Filters
              </button>
            )}
          </motion.div>
        </div>
      ) : (
        <>
          <div className="container px-2">
            <motion.div
              layout
              className="row gy-4 justify-content-center product-grid-container"
              initial="hidden"
              animate="visible"
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: { staggerChildren: 0.05 },
                },
              }}
            >
              {currentData.map((product) => {
                const isSoldOut = product.stock === 0;
                const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === product.id);

                return (
                  <motion.div key={product.id} className="col-6 col-sm-6 col-md-4 col-lg-3">
                    <motion.div className="card h-100 border-0 premium-card-wrapper">
                      <div>
                        <div className="symmetric-image-frame">
                          {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

                          <div
                            onClick={() => !wishlistLoading && toggleWishlist(product)}
                            style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", zIndex: 2 }}
                          >
                            {isInWishlist ? <FaHeart size={22} color="red" /> : <CiHeart size={22} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />}
                          </div>

                          <motion.img
                            src={product.item_photo || logo}
                            alt={product.title}
                            className="symmetric-cover-img"
                            onClick={() => handleProductClick(product.id)}
                            whileHover={{ scale: 1.02 }}
                            transition={{ duration: 0.2 }}
                          />
                        </div>

                        <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
                          <h6 
                            className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size modal-trigger-area" 
                            style={{ fontSize: "14px" }}
                            onClick={() => handleProductClick(product.id)}
                          >
                            {product.title}
                          </h6>
                          <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px", flexWrap: "wrap" }}>
                            <p
                              className="old-price mb-0 mobile-price-size"
                              style={{
                                textDecoration: `${product.item_old_price === product.item_new_price ? "auto" : "line-through"}`,
                                color: "#999",
                                fontSize: "0.83333rem",
                              }}
                            >
                              ₹{product.item_old_price || 0}
                            </p>
                            <p className="fw-semibold mb-0 mobile-price-size" style={{ fontSize: "0.83333rem" }}>
                              ₹{product.item_new_price}
                            </p>
                            <p className="discount-badge mb-0 fw-bold" style={{ color: 'green', fontSize: '12px' }}>
                              {product.discount_percentage}% OFF
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="w-100 mt-3">
                        {cartItems[product.id] && !isSoldOut ? (
                          <div className="d-flex justify-content-center align-items-center gap-2">
                            <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => subOne(product.id)}>-</button>
                            <span className="fw-bold text-dark mx-2">{cartItems[product.id]}</span>
                            <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', padding: 0 }} onClick={() => addOne(product.id)}>+</button>
                          </div>
                        ) : (
                          <motion.button
                            whileHover={{ scale: 1.02 }}
                            className="btn text-white w-100 fw-bold rounded-pill shadow-none"
                            onClick={() => onPressAddToCart(product.id)}
                            disabled={isSoldOut}
                            style={{ backgroundColor: "#5dc5fa", border: "none", padding: "8px 0", fontSize: "13px" }}
                          >
                            Add to Cart
                          </motion.button>
                        )}
                      </div>
                    </motion.div>
                  </motion.div>
                );
              })}
            </motion.div>

            {totalPages > 1 && (
              <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4, px: 2 }}>
                <StyledPagination
                  count={totalPages}
                  page={itemsPage}
                  onChange={(event, value) => {
                    setItemsPage(value);
                    sessionStorage.setItem('productPage', value.toString());
                    sessionStorage.setItem('productCategory', selectedCategory);
                  }}
                  shape="rounded"
                  color="primary"
                  size="medium"
                />
              </Stack>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Product;